import { Component, h, State, Prop, Element, Watch, Listen, Event, EventEmitter, Method, Env, Host } from "@stencil/core"
import { io, Socket } from "socket.io-client"
import showdown from "showdown"

import {
  getEndpoint,
  generateUUID,
  updateButtonEvents,
  getConfig,
  getOrCreateVisitorId,
  getComponentByControlType,
  splitContent,
  getMetaInfo,
  getBroswerLang,
  getAllLanguagesInSurvey,
  checkStatus,
} from "../../utils/utils"
import Handlebars from "handlebars"
import { setBotElement } from "../../utils/global-store"
// import $ from "jquery"
// import { Model } from "survey-jquery"

@Component({
  tag: "ai12z-bot",
  styleUrls: ["./ai12z-bot.css", "../../global/tailwind.min.css", "../../global/survey.min.css", "./ai12z-chatbot.css"],
  shadow: true,
})
export class Ai12zBot {
  private cdnPath: string = "https://cdn.ai12z.net/assets/bot"
  @Element() el: HTMLElement

  @Prop({ reflect: true }) dataKey: string = Env.DATA_KEY || ""
  @Prop({ reflect: true }) dataMode: string = Env.DATA_MODE || "prod" // "local", "dev", or "prod"
  @Prop({ reflect: true }) configId: string
  @Prop({ reflect: true }) dataAttributes: string
  @Prop() excludeTags: Array<string> = []
  @Prop() includeTags: Array<string> = []

  // @Prop({ reflect: true }) type: string = "v1"

  @State() botSettings: any = {}
  @State() canRender = true
  @State() isOpen: boolean = false
  @State() isListening: boolean = false
  @State() showSubmit: boolean = false
  @State() hideAllButtons: boolean = false
  @State() showMenu: boolean = false

  @State() botlogo: string = this.cdnPath + `/v1/ai12z-bot/img/chatbot.jpg`
  @State() botAvatar: string = this.cdnPath + `/v1/ai12z-bot/img/chatbot.jpg`

  @State() showWelcomeScreen: boolean = true
  @State() hideInput: boolean = false
  @State() showHistory: boolean = false
  @State() conversationId: string = ""
  @State() surveyDomId: string = ""
  @State() searchResults: any = {}
  @State() buttons: Array<{ id: string; label: string }> = []
  @State() currentDomId: string = ""
  @State() messages: { text: string; isUser: boolean; id: string; timestamp: string; images: any[]; conversationId: string; formModel: any; surveyDomId: string }[] = [
    // { text: this.welcomeMessage === "" ? "Hi there! How can I assist you today" : this.welcomeMessage, isUser: false, id: `chatbot-${generateUUID()}`, timestamp: "", images: [] },
  ]
  @State() questionCounter: number = 0
  @State() isChatOpen: boolean = false
  @State() visitorID: string
  @State() timestamp: string = ""
  @State() rowCount = 1
  @State() isBot = false
  @State() conversationHistory = []
  @State() isMenuOpen: boolean = false
  @State() query: string = ""
  @State() scriptArray = []
  private customStyle: string = ""
  private customJS: string = ""
  private timer: NodeJS.Timeout
  private inputEl!: HTMLTextAreaElement
  private uploadElem: HTMLInputElement
  private followUpElem: HTMLInputElement
  private dataOverrideFunction: ((data: any) => Promise<any>) | null = null
  menuRef: HTMLElement
  menuV2Ref: HTMLElement
  plusIconRef: HTMLElement
  private socket: Socket
  imagesBase64List = []

  /* new ersion of bot */
  @State() isAnimated = false
  @State() isMinimized: boolean = false
  @State() isOpened = false
  @State() isContent = false
  @State() isExpanded: boolean
  @State() isToggled = false
  @State() showTextarea: boolean = false // Changing this will trigger a re-render
  @State() showPrivacy: boolean = false // Changing this will trigger a re-render
  @State() isRendered: boolean = false // Flag to track if the component has been rendered
  @Event({
    eventName: "messageSent",
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  messageSent: EventEmitter
  @Event({
    eventName: "messageReceived",
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  messageReceived: EventEmitter

  @Event({
    eventName: "close",
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  close: EventEmitter

  @Event({
    eventName: "open",
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  open: EventEmitter

  @Event({
    eventName: "minimize",
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  minimize: EventEmitter

  @Event({
    eventName: "errored",
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  errored: EventEmitter

  @Event({
    eventName: "formSubmitted",
    composed: true,
    cancelable: true,
    bubbles: true,
  })
  formSubmitted!: EventEmitter<any>

  toggleBox = () => {
    this.isOpen = !this.isOpen
  }

  toggleBot = e => {
    e.stopPropagation()
    this.isToggled = !this.isToggled
  }
  toggleListening = () => {
    this.isListening = !this.isListening
  }

  @Listen("buttonClick")
  buttonClickHandler(event: CustomEvent) {
    this.showWelcomeScreen = false
    this.hideInput = false
    this.query = event.detail.action
    this.handleSend(event.detail.label)
  }

  @Listen("sendQueryToBot")
  sendQueryToBotHandler(event: CustomEvent) {
    this.showWelcomeScreen = false
    this.hideInput = false
    this.query = event.detail
    this.handleSend(event.detail)
  }

  @Listen("deleteChatHistory")
  deleteChatHistoryHandler(event: CustomEvent) {
    const chatHistory = this.getConversationHistory()
    const updatedHistory = chatHistory.filter(item => item.conversationId !== event.detail.conversationId)
    localStorage.setItem(`${this.visitorID}`, JSON.stringify(updatedHistory))
    this.conversationHistory = updatedHistory
  }

  @Listen("chatClick")
  chatClickHandler(event: CustomEvent) {
    this.messages = event.detail
    this.showWelcomeScreen = false
    this.hideInput = false
    this.showHistory = false
  }

  @Listen("openChat")
  openChatHandler(_event: CustomEvent) {
    this.isChatOpen = true
  }

  @Listen("formComplete")
  formSubmittedHandler(event: CustomEvent) {
    event.stopPropagation()
    this.formSubmitted.emit(event.detail.data)
  }

  handleClickOutside(event: MouseEvent) {
    // Check if the clicked target is outside the menu
    const target = event.target as HTMLElement
    if (this.isMenuOpen && this.menuRef && !this.menuRef.contains(target)) {
      this.isMenuOpen = false
    }

    if (this.isToggled && this.menuV2Ref && !this.menuV2Ref.contains(target)) {
      // console.log("Clicked outside the menu, closing...")
      this.isToggled = false
    }

    if (this.showMenu && this.plusIconRef && !this.plusIconRef.contains(target)) {
      this.showMenu = false
    }
  }

  componentDidLoad() {
    setBotElement(this.el) // register globally
    // console.log("Bot Settings getAssetPath")
    // this.updateScreenSize()
    window.addEventListener("resize", this.updateScreenSize.bind(this))
    // debugger;
    document.addEventListener("click", this.handleClickOutside.bind(this))
    // Load jQuery first
    const jQueryScript = document.createElement("script")
    jQueryScript.src = this.cdnPath + "/v1/jquery.min.js" // Path relative to the www root
    jQueryScript.onload = () => {
      // console.log("jQuery loaded")
      // Load the script that loads and exposes SurveyJS
      const loadSurveyScript = document.createElement("script")
      loadSurveyScript.src = this.cdnPath + "/v1/survey.jquery.min.js" // Path relative to the www root
      loadSurveyScript.onload = () => {
        // console.log("SurveyJS loaded and SurveyModel exposed")
      }
      loadSurveyScript.onerror = err => {
        console.error("Failed to load Forms:", err)
      }
      document.head.appendChild(loadSurveyScript)
      this.el.shadowRoot.appendChild(loadSurveyScript)
    }
    jQueryScript.onerror = err => {
      console.error("Failed to load jQuery:", err)
    }
    document.head.appendChild(jQueryScript)

    const ai12zHeading = document.createElement("script")
    ai12zHeading.text = `
      var ai12zChat = window["ai12z"] = {}
    `
    document.head.appendChild(ai12zHeading)
    this.el.shadowRoot.appendChild(ai12zHeading)
    this.el.shadowRoot.appendChild(jQueryScript)
  }

  disconnectedCallback() {
    // Remove event listener when component is destroyed
    document.removeEventListener("click", this.handleClickOutside.bind(this))

    window.removeEventListener("resize", this.updateScreenSize)

    // clearInterval(this.timer)
  }

  checkHistory = () => {
    const storedMessages = localStorage.getItem(`${this.visitorID}`)
    let chatHistory = []
    if (storedMessages) {
      chatHistory = JSON.parse(storedMessages)
      chatHistory = chatHistory.filter(item => item.projectId === this.botSettings?.pId)
    }
    this.showHistory = chatHistory.length > 0 && this.botSettings.botVersion === "v1" ? true : false
    // console.log("showHistory", this.showHistory)
  }

  @Method()
  async sendMessage(message: string, displayText?: string) {
    this.query = message
    if (!this.isChatOpen) {
      this.isChatOpen = true
    }

    this.handleSend(displayText ?? message)
  }

  @Method()
  async sendQuery(query: string) {
    console.warn("sendQuery mehtdod is deprecated, use sendMessage instead")
    this.handleSend(query)
  }

  @Method()
  async sendJSON(jsonData: Object, displayText: string) {
    this.query = JSON.stringify(jsonData)
    if (!this.isChatOpen) {
      this.isChatOpen = true
    }
    this.handleSend(displayText)
  }

  setLocalData() {
    const botData = { qCounter: this.questionCounter }
    localStorage.setItem(`ai12z-bot-data`, JSON.stringify(botData))
  }

  @Method()
  async openBot(expanded: boolean = false) {
    this.openChat(expanded)
  }

  @Method()
  async action(type, options?: any) {
    // this.isChatOpen = !this.isChatOpen
    if (type === "open") {
      this.openChat(options?.expanded ?? false)
    }
    if (type === "minimize" && this.isOpened) {
      this.minimizeChat()
    }
    const getVisitorKey = localStorage.getItem(`ai12z-visitorId`)
    this.visitorID = "ai12z-" + getVisitorKey
    this.checkHistory()
    if (type === "close") {
      this.isChatOpen = false
      this.searchResults = {}
      this.surveyDomId = ""
      this.showWelcomeScreen = true
      this.showHistory = this.messages.length > 0 ? true : false
      // this.saveConversation()
      this.messages = [...[]]
      this.conversationId = ""
      this.close.emit("close")
      clearInterval(this.timer)
    }
  }

  async processDataOverride(data: any): Promise<any> {
    // Check if a custom override function has been set
    if (this.dataOverrideFunction && typeof this.dataOverrideFunction === "function") {
      try {
        return await this.dataOverrideFunction(data)
      } catch (error) {
        console.error("Error in custom processDataOverride:", error)
        throw error
      }
    }

    // Default implementation - return the data as-is
    return data
  }

  // Method to set the override function
  @Method()
  async setProcessDataOverride(overrideFunction: (data: any) => Promise<any>): Promise<void> {
    this.dataOverrideFunction = overrideFunction
  }
  openChat(expanded: boolean = false) {
    this.isOpened = true
    this.isExpanded = expanded
    this.isMinimized = false
    this.isContent = false
    this.open.emit("open")
    this.toggleTextarea()
  }

  minimizeChat() {
    this.isOpened = false
    // this.isContent = false
    this.isContent = this.isExpanded ? true : false
    this.isMinimized = this.isExpanded ? false : true
    this.isAnimated = false
    this.updateScreenSize()
    this.minimize.emit("minimize")
  }

  private get mainObject(): any {
    if (!window["ai12z"]) {
      window["ai12z"] = {}
    }
    return window["ai12z"]
  }

  toggleMenu(e) {
    e.stopPropagation()
    this.isMenuOpen = !this.isMenuOpen
  }

  adjustHeight() {
    if (this.inputEl) {
      this.inputEl.style.height = "auto"
      this.inputEl.style.height = this.inputEl.scrollHeight + "px"
    }
  }

  connectedCallback() {
    //this.parseMyObjectProp(this.myObject);
    checkStatus(this.dataKey, this.dataMode).then(enable => {
      this.canRender = enable
      // if (!enable) {
      //   console.log("ai12z canRender", this.canRender)
      // }
    })
    this.configBot()
  }

  componentWillLoad() {
    this.checkCustomSlot()
    this.timestamp = this.formatTimestamp(new Date())
    this.updateScreenSize()
    // this.socketConnection()
    // this.configBot()
  }

  configBot() {
    const payload = {
      apiKey: this.dataKey,
      configId: this.configId,
      configType: "bot",
    }
    getConfig(payload, this.dataMode).then(data => {
      if (data) {
        // console.log("Bot Settings", data)
        this.botSettings = data
        if (!this.botSettings.botVersion) {
          this.botSettings.botVersion = "v1" // Default to v1 if not specified
        }
        if (this.botSettings.botVersion === "v2" && !this.botSettings.isExpanded && !this.isBot) {
          // this.botSettings.imageUpload = true
          this.isMinimized = true
        }
        // console.log("isbot", this.isBot)
        if (this.botSettings.isExpanded && !this.isBot) {
          this.isExpanded = true
          this.isMinimized = false
        } else {
          this.isMinimized = true
        }
        if (!this.botSettings.linkTarget) {
          this.botSettings.linkTarget = "_blank"
        }
        if (this.botSettings.botVersion === "v2") {
          const getVisitorKey = localStorage.getItem(`ai12z-visitorId`)
          this.visitorID = "ai12z-" + getVisitorKey
          this.toggleTextarea()
        }
        if (this.botSettings.privacyTemplate && this.botSettings.privacyTemplate !== "") {
          this.showPrivacy = true
        }
        if (this.botSettings.customCSS) {
          this.customStyle = this.botSettings.customCSS
          this.insertStyles(this.botSettings.customCSS)
        }
        if (this.botSettings.customJS) {
          this.customJS = this.botSettings.customJS
          const scriptEl = document.createElement("script")
          scriptEl.setAttribute("type", "text/javascript")
          scriptEl.setAttribute("src", this.botSettings.customJS)
          this.el.shadowRoot?.appendChild(scriptEl)
        }
        this.isRendered = true // Set the flag to true after rendering
      }
    })
  }

  insertStyles(linkURL: string) {
    const linkEl = document.createElement("link")
    linkEl.setAttribute("rel", "stylesheet")
    linkEl.setAttribute("href", linkURL)

    const shadowRoot = this.el.shadowRoot
    if (shadowRoot) {
      shadowRoot.appendChild(linkEl)
    }
  }

  checkCustomSlot() {
    const slot = this.el["children"]
    let slotHasContent = slot && slot.length > 0
    // console.log("slotcontent", slotHasContent)
    if (slotHasContent) {
      for (var i = 0; i < slot.length; i++) {
        // console.log(slot[i])
        if (slot[i].tagName.toLowerCase() === "bot" || slot[i].getAttribute("slot") === "bot") {
          this.isBot = true
          this.isExpanded = false
        }
      }
    }
  }

  @Watch("currentDomId")
  watchStateHandler(_newValue: boolean, _oldValue: boolean) {
    this.socket.off("response")
    this.socket.off("end_response")
    // console.log("currentDomId changed")
    // console.log("questionCounter", this.botSettings.maxQuestion)
    if (this.botSettings.maxQuestion === undefined || this.botSettings.maxQuestion === 0) {
      this.botSettings.maxQuestion = 0
      this.handleBotMessages()
    } else if (this.questionCounter <= this.botSettings.maxQuestion) {
      this.handleBotMessages()
    }
  }

  generateMessage() {
    return {
      text: "",
      isUser: false,
      id: `chatbot-${generateUUID()}`,
      timestamp: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      images: [],
      conversationId: this.conversationId,
      formModel: {},
      surveyDomId: "",
    }
  }
  hideSpinner(chatData) {
    // Logic for hiding the spinner (assumed to return a Promise if async is needed)
    return new Promise(resolve => {
      const renderedBubble = this.el.shadowRoot.querySelector(`#${chatData.id}`)
      if (renderedBubble) {
        ;(renderedBubble.querySelector("#spinner") as HTMLElement).style.display = "none"
      }
      // Assume some async action here, then resolve
      // console.log("Spinner hidden")
      resolve(true)
    })
  }

  async processTemplateData(chatData, data) {
    // Step 1: Hide the spinner
    await this.hideSpinner(chatData)
    let handletemplate
    let currentResponse

    if (data.controlType === "template") {
      const currentTemplate = data.controlData?.template
      currentResponse = data.controlData?.data.source
      handletemplate = Handlebars.compile(currentTemplate[0]?.content)
    }

    // Step 3: Append the control element if both it and the target container exist
    const targetContainer = this.el.shadowRoot.querySelector(`#${chatData.id}`)
    if (targetContainer) {
      Handlebars.registerHelper("processArray", function (array) {
        if (!Array.isArray(array)) {
          return "" // Return an empty string if the input is not an array
        }
        return new Handlebars.SafeString(JSON.stringify(array))
      })
      // console.log("data", data.controlData)
      if (data.controlData && data.controlData.data) {
        data.controlData.data.msgId = chatData.id //`msg-${chatData.id}`
      }
      targetContainer.innerHTML = handletemplate({ msgId: `${chatData.id}`, source: currentResponse, llm: data.controlData.data.llm })
      targetContainer.classList.add("overflow-x-auto")
      targetContainer.classList.add("scroll-nobar")
      setTimeout(() => {
        this.renderTemplateData(chatData)
      }, 1000)
      // Step 4: Wait until the control element is rendered
      await this.waitForElementRender(targetContainer as HTMLElement)

      // Step 5: Retrieve the content and emit the updated data
      chatData.text = targetContainer.innerHTML

      this.messages = this.messages.map(item => (item.id === chatData.id ? chatData : item))
    }
  }

  renderTemplateData(chatData) {
    // console.log(`#${chatData.id}`)

    if (!this.mainObject[`${chatData.id}`]) {
      this.mainObject[`${chatData.id}`] = {}
    }
    const scripts = this.el.shadowRoot.querySelectorAll(`#${chatData.id} script`)
    scripts.forEach(script => {
      const newScript = document.createElement("script")
      newScript.type = "text/javascript"

      // If it's an external script (with `src`), copy the `src` attribute
      if ((script as HTMLScriptElement).src) {
        newScript.src = (script as HTMLScriptElement).src
      } else {
        // If it's inline, set the JavaScript code as the content of the new <script> element
        // newScript.innerHTML = `const source = ${JSON.stringify(chatData.data.source)};\n`
        // newScript.innerHTML += `const llm = ${JSON.stringify(chatData.data.llm)};\n`
        newScript.innerHTML += script.innerHTML
      }
      // Append the new script to the document body to execute it
      if (!newScript.src) {
        this.scriptArray.push(newScript)
      }
      script.parentNode?.removeChild(script)

      // Optionally, remove the old <script> tag from the DOM

      if (newScript.src && !this.el.shadowRoot.querySelector(`script[src="${newScript.src}"]`)) {
        this.el.shadowRoot.appendChild(newScript)
      } else {
        const scriptDom = this.el.shadowRoot.querySelector(`script[type="text/javascript"]`)
        // console.log("scriptDom", scriptDom)
        // console.log("newScript", newScript)
        if (scriptDom && !newScript.src) {
          // console.log("scriptDom", this.scriptArray)
          if (this.scriptArray.length > 0) {
            this.scriptArray.forEach(script => {
              if (!script.src && script.innerHTML !== newScript.innerHTML) {
                this.el.shadowRoot.appendChild(newScript)
              }
            })
          } else {
            // console.log("ele", this.el.shadowRoot)
            this.el.shadowRoot.appendChild(newScript)
          }
          // this.el.shadowRoot.appendChild(newScript)
        } else {
          // console.log("scriptDom not found")
          this.el.shadowRoot.appendChild(newScript)
        }
      }
    })
    // Step 4: Ensure Google Charts is loaded, then call the `drawGoogleChart` function
    setTimeout(() => {
      this.initializeScript(chatData.id)
    }, 1000)
  }

  initializeScript(id) {
    if (typeof this.mainObject[`${id}`]["onLoadCallback"] === "function") {
      this.mainObject[`${id}`]["onLoadCallback"]()
    }
    // window["google"]?.charts.load("current", { packages: ["corechart"] })
    // window["google"]?.charts.setOnLoadCallback()
  }

  async processChatData(chatData, data) {
    // Step 1: Hide the spinner
    await this.hideSpinner(chatData)

    if (data.controlData?.data?.source) {
      data.controlData.data.source.customCss = this.customStyle || ""
      data.controlData.data.source.customJs = this.customJS || ""
    }
    // Step 2: Get the control element based on control type
    const controlElement = getComponentByControlType(data, "bot")

    const tmpControlType = data.controlData?.data?.source?.carousel?.type

    // Step 3: Append the control element if both it and the target container exist
    const targetContainer = this.el.shadowRoot.querySelector(`#${chatData.id}`)
    if (targetContainer && controlElement) {
      // console.log("controlElement", targetContainer)
      targetContainer.appendChild(controlElement)
      targetContainer["style"].width = "98%"

      if (tmpControlType === "custom" || tmpControlType === "list" || tmpControlType === "slider") {
        targetContainer.classList.remove("p-2.5")
        targetContainer.classList.add("p-0")
        targetContainer.classList.add("md:p-2.5")
      }

      // Step 4: Wait until the control element is rendered
      await this.waitForElementRender(targetContainer as HTMLElement)
      // console.log("targetContainer", targetContainer)
      // Step 5: Retrieve the content and emit the updated data
      chatData.text = targetContainer.innerHTML
      this.messages = this.messages.map(item => (item.id === chatData.id ? chatData : item))
    }
  }

  // Helper function to detect when the target element is rendered
  waitForElementRender(element: HTMLElement) {
    return new Promise<void>(resolve => {
      const observer = new MutationObserver(_mutations => {
        resolve()
        observer.disconnect()
      })
      observer.observe(element, { childList: true, subtree: true })
    })
  }

  handleBotMessages() {
    // const domId = this.messages[this.messages.length - 1].id
    this.socket.on("response", event => {
      this.handleMessage(event.data, `${this.currentDomId}`) // Use the unique ID to handle messages
    })
    this.socket.on("end_response", data => {
      // console.log("end_response")
      this.messageReceived.emit(data)
      const converter = new showdown.Converter()
      let finalHtml = converter.makeHtml(data.answer)
      // document.getElementById("messageId").innerHTML = finalHtml;
      finalHtml = this.updateAnchorTags(finalHtml)
      finalHtml = updateButtonEvents(finalHtml).body
      this.buttons = updateButtonEvents(finalHtml).buttons
      this.searchResults = data
      this.conversationId = data.conversationId
      if (finalHtml.indexOf("[control") > -1) {
        // console.log("controlType", data.controlType)
        switch (data.controlType) {
          case "form":
            this.surveyDomId = "surveyElement-" + generateUUID()
            finalHtml = finalHtml.replace(RegExp(/\[[^>]*]/gm), `<div id=${this.surveyDomId} style="width:${this.botSettings.botVersion === "v1" ? "330px" : "100%"}"></div>`)
            // finalHtml = `<div id=${this.surveyDomId} style="width:${this.botSettings.botVersion === "v1" ? "330px" : "100%"}"></div>`
            this.el.shadowRoot.querySelector(`#${this.currentDomId}`).innerHTML = finalHtml
            this.updateConversations(finalHtml, data)
            break
          case "carousel":
          case "list":
          case "template":
            if (data.controlType && data.controlType !== null) {
              const newContent = splitContent(finalHtml)
              finalHtml = newContent.before
              this.updateConversations(finalHtml, data)
              const newMessage = this.generateMessage()
              this.messages = [...this.messages, newMessage]
              setTimeout(() => {
                data.controlType === "template" ? this.processTemplateData(newMessage, data) : this.processChatData(newMessage, data)
              }, 2000)
              if (newContent.after.trim().length > 0) {
                const afterMessage = this.generateMessage()
                afterMessage.text = newContent.after
                this.messages = [...this.messages, afterMessage]
                setTimeout(() => {
                  if (afterMessage.id) {
                    const bubbleEle = this.el.shadowRoot.querySelector(`#${afterMessage.id}`)
                    if (bubbleEle && (bubbleEle.querySelector("#spinner") as HTMLElement)) {
                      ;(bubbleEle.querySelector("#spinner") as HTMLElement).style.display = "none"
                    }
                  }
                }, 500)
              }
            }
        }
      } else {
        const currentDomElement = this.el.shadowRoot.querySelector(`#${this.currentDomId}`) as HTMLElement
        if (currentDomElement) {
          currentDomElement.style.width = "auto"
        }
        this.el.shadowRoot.querySelector(`#${this.currentDomId}`).innerHTML = finalHtml
        this.updateConversations(finalHtml, data)
      }

      this.saveConversation()
      this.scrollToBottom()
    })
  }

  updateAnchorTags(htmlContent: string) {
    const parser = new DOMParser()
    const doc = parser.parseFromString(htmlContent, "text/html")
    const anchorTags = Array.from(doc.querySelectorAll("a"))

    anchorTags.forEach(anchor => {
      // console.log("targtet")
      anchor.setAttribute("target", this.botSettings.linkTarget)
      anchor.classList.add("ai12z-link")
    })

    // Update the htmlContent with the modified anchor tags
    return doc.body.innerHTML
  }

  updateConversations(finalHtml, data) {
    const updatedmsg = {
      id: this.currentDomId,
      text: finalHtml,
      isUser: false,
      timestamp: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
      images: [],
      conversationId: this.conversationId,
      formModel: data.controlData?.data?.source ?? data.controlData ?? {},
      surveyDomId: this.surveyDomId,
    }
    this.addEventListeners(`#${this.currentDomId}`)
    this.messages = this.messages.map(item => (item.id === this.currentDomId ? updatedmsg : item))
  }

  @Watch("surveyDomId")
  watchSurveyDomIdHandler(_newValue: boolean, _oldValue: boolean) {
    setTimeout(() => {
      this.renderSurvey(this.searchResults)
    }, 1000)
  }

  resolveLocalized(value: any, fallback: string = ""): string {
    if (!value) return fallback

    if (typeof value === "string") {
      return value
    }

    if (typeof value === "object") {
      return value[getBroswerLang()] || value.default || fallback
    }

    return fallback
  }

  alertResults = sender => {
    // console.log("Survey results", sender.keyName)
    this.formSubmitted.emit(sender.data)
    // console.log("survey results", sender.jsonObj)
    // const results = JSON.stringify(sender.data)
    let results = JSON.parse(JSON.stringify(sender.data))

    // results.description = sender.jsonObj.description ? sender.jsonObj.description : ""
    // const completedHtml = sender.jsonObj.completedHtml ? sender.jsonObj.completedHtml : "Thank You!"
    // const completeText = sender.jsonObj.completeText ? sender.jsonObj.completeText : "Submit"

    results.description = this.resolveLocalized(sender.jsonObj.description, "")
    const completedHtml = this.resolveLocalized(sender.jsonObj.completedHtml, "Thank You!")
    const completeText = this.resolveLocalized(sender.jsonObj.completeText, "Submit")
    // Object.assign(results.data, { description: sender.jsonObj.description })
    // console.log("sender", results)
    // const query = "Here is the data you requested:" + results
    // this.query = query
    const domId = sender.implementor.renderedElement.id
    // const surveyDataId = domId.replace("surveyElement-", "")
    // sender.implementor.renderedElement.innerHTML = `<p><b>Thank you</b></p>`
    // console.log("messages", this.messages)
    const idx = this.messages.findIndex(item => item.surveyDomId === domId)
    this.currentDomId = this.messages[idx].id
    this.surveyDomId = domId
    this.updateConversations(completedHtml, {})
    const jsonData = `This JSON is from a form submission [${sender.keyName}]: ${JSON.stringify(results, null, 2)}. There is no need to show the form [${sender.keyName}] again.`
    // this.sendJSON(results, completeText)
    this.sendMessage(jsonData, completeText)
    // const lastMessage = {
    //   text: "",
    //   isUser: false,
    //   id: `chatbot-${generateUUID()}`,
    //   timestamp: new Date().toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" }),
    //   images: [],
    //   conversationId: this.conversationId,
    //   formModel: {},
    //   surveyDomId: "",
    // }
    // this.currentDomId = lastMessage.id
    // this.surveyDomId = domId

    // if (idx === -1) {
    //   // this.handleSubmit(null, query, "survey-res", false, null)
    //   this.messages.splice(this.messages.length - 1, 1)
    //   this.messages = [...this.messages, lastMessage]
    // } else {
    //   this.messages = [...this.messages.slice(0, idx), lastMessage, ...this.messages.slice(idx + 1)]
    // }

    this.scrollToBottom()
    // this.invokeSocket()
  }

  renderSurvey = chat => {
    window["Survey"].Serializer.addProperty("survey", {
      name: "keyName:string",
      visible: false, // makes it appear in Survey Creator
      category: "general", // optional, groups the property
      default: "", // optional default value
    })
    let formModel = chat.controlData?.data?.source ?? chat.controlData
    if (typeof formModel === "object") {
      formModel.keyName = chat.keyName
    } else {
      formModel = JSON.parse(formModel)
      formModel.keyName = chat.keyName
    }

    let supportedLocales
    if (formModel) {
      supportedLocales = getAllLanguagesInSurvey(formModel)
    }
    // console.log("supportedLocales", supportedLocales)
    if (supportedLocales.has(getBroswerLang())) {
      window["Survey"].surveyLocalization.currentLocale = getBroswerLang()
    } else {
      window["Survey"].surveyLocalization.currentLocale = "default"
    }

    // const supportedLocales = Object.keys(formModel.description) // ['default', 'fr']
    // window["Survey"].surveyLocalization.currentLocale = supportedLocales.includes(getBroswerLang()) ? getBroswerLang() : "default"
    const survey = new window["Survey"].Model(formModel)
    if (this.surveyDomId === "") {
      return
    }
    const domELe = this.el.shadowRoot?.querySelector(`#${this.surveyDomId}`)
    if (domELe) {
      window["jQuery"](domELe).Survey({ model: survey })
    } else {
      console.error("Survey Element not found")
    }

    if (typeof chat.controlData?.data?.source == "object" || typeof chat.controlData === "object") {
      this.hideCompleteButton(chat.controlData?.data?.source ?? chat.controlData, survey)
    } else {
      this.hideCompleteButton(JSON.parse(chat.controlData?.data?.source ?? chat.controlData), survey)
    }
    // survey.completeText = "Submit"
    survey.showCompletedPage = false
    if (chat.theme) {
      survey.applyTheme(JSON.parse(chat.theme))
    }
    survey.onAfterRenderQuestionInput.add(function (_, options) {
      options.htmlElement.name = options.question.name
    })
    survey.onComplete.add(this.alertResults)
  }

  hideCompleteButton(form: any, survey) {
    survey.completeText = form?.completeText ?? "Submit"
    survey.completedHTML = form?.completedHtml ?? "Thank You!"
    if (form && form.pages) {
      form.pages.forEach((page: any) => {
        if (page.elements) {
          // console.log("page.elements", page.elements)
          page.elements.forEach((element: any) => {
            if (element.type === "html") {
              if (element.html.includes("<iframe")) {
                survey.showCompleteButton = false
              }
            }
          })
        }
      })
    }
  }

  addEventListeners(msgId) {
    const container = this.el.shadowRoot.querySelector(msgId)
    if (container) {
      this.buttons.forEach(button => {
        const buttonElement = container.querySelector(`#${button.id}`)
        if (buttonElement) {
          const originalCall = buttonElement.getAttribute("data-original-click") // Ensure type safety or handle undefined
          if (!originalCall) {
            console.warn(`originalClickHandler is not defined for button with id: ${button.id}`)
            return
          }

          // const match = originalCall.match(/^(\w+)\s*\((.*)\)$/) // extract name and arguments
          const match = originalCall.match(/^(\w+)\s*\(([\s\S]*)\)$/)
          // console.log("match", match)
          if (match) {
            const funcName = match[1]
            const argsStr = match[2] // string of args, like "'param', true"
            const self = this
            const func = self[funcName]
            buttonElement.addEventListener("click", () => {
              if (typeof this[funcName] === "function") {
                try {
                  // console.log("args", argsStr)
                  // Evaluate arguments safely
                  switch (funcName) {
                    case "sendQuery":
                      const args = eval(`[${argsStr}]`)
                      args[0] = button.label
                      func.apply(self, args)
                      break
                    case "sendMessage":
                      const msgArgs = eval(`[${argsStr}]`)
                      func.apply(self, msgArgs)
                      break

                    case "sendJSON":
                      const tempArgs = argsStr.match(/^'(.*?)'\s*,\s*'(.*?)'$/)

                      const rawObjectStr = tempArgs[1]
                        .replace(/([{,])\s*(\w+)\s*:/g, '$1"$2":') // quote keys
                        .replace(/:\s*'([^']*)'/g, ': "$1"') // convert single to double quotes

                      const parsedObj = JSON.parse(rawObjectStr)
                      const jsonArgs = [parsedObj, tempArgs[2]]
                      func.apply(self, jsonArgs)
                      break
                  }
                } catch (err) {
                  console.error(`Error invoking ${funcName}:`, err)
                }
              } else {
                console.warn(`Function ${funcName} not found on this`)
              }
            })
            // buttonElement.addEventListener("click", this.handleButtonClick(button.label))
          }
        }
      })
    }
  }

  handleButtonClick = (label: string) => (_event: Event) => {
    this.inputEl.value = label
    this.handleSend(label)
  }

  formatTimestamp(date: Date) {
    const today = new Date()
    today.setHours(0, 0, 0, 0)
    const options: Intl.DateTimeFormatOptions = {
      weekday: "long",
      hour: "numeric",
      minute: "numeric",
      hour12: true,
    }
    const formatter = new Intl.DateTimeFormat("en-US", options)
    const formattedDate = formatter.format(date)

    if (date.toDateString() === today.toDateString()) {
      return `Today, ${formattedDate.split(" ").slice(1).join(" ")}`
    } else {
      return formattedDate
    }
  }

  async socketConnection() {
    let a12z_EndPoint = getEndpoint(this.dataMode)
    this.socket = io(a12z_EndPoint, { transports: ["polling"] })

    await new Promise<void>(resolve => {
      this.socket.on("connect", () => {
        // console.log("Connected to Socket.IO server")
        resolve()
      })
    })

    this.socket.on("connect_error", error => {
      this.errored.emit(error)
      console.error("Connection error:", error)
    })

    this.socket.on("disconnect", () => {
      // console.log("Disconnected from Socket.IO server")
      this.socket.off("response")
      // Handle disconnection if needed
    })
  }

  invokeSocket() {
    const data = {
      apiKey: this.dataKey,
      query: this.query !== "" ? this.query : this.inputEl.value,
      conversationId: this.conversationId,
      event: "evaluate_query",
      attributes: this.dataAttributes,
      excludeTags: this.excludeTags,
      includeTags: this.includeTags,
      base64Images: this.imagesBase64List,
      meta: getMetaInfo(),
    }
    // Call the override method to allow developer processing
    this.processDataOverride(data)
      .then(processedData => {
        // If null is returned, stop execution
        if (processedData === null || processedData === undefined) {
          console.log("Data processing returned null, stopping execution")
          return
        }

        this.messageSent.emit(JSON.stringify(processedData))

        this.socket.emit("evaluate_query", processedData, (error, _response) => {
          if (error) {
            this.errored.emit(error)
            console.error("Error:", error)
          } else {
            // console.log("Response:", response)
          }
        })

        if (this.inputEl) {
          this.inputEl.value = ""
          this.adjustHeight()
        }
        this.query = ""
      })
      .catch(error => {
        console.error("Error in processDataOverride:", error)
        this.errored.emit(error)
      })
  }

  handleMessage = (data, aiMessageId) => {
    const converter = new showdown.Converter()
    // const aiMessageBubble = document.getElementById(aiMessageId);

    const aiMessageBubble = this.el.shadowRoot?.querySelector(`#${aiMessageId}`)
    // const aiMessageBubble = this.element.querySelector('.ai12z-suggest-answer')

    if (!aiMessageBubble) {
      console.error(`Message bubble with ID ${aiMessageId} not found.`)
      return
    }
    var bubbleText = aiMessageBubble.getAttribute("data-bubbleText") || ""
    bubbleText = bubbleText + data
    aiMessageBubble.setAttribute("data-bubbleText", bubbleText)

    // Assuming data is a string containing the message content
    let html = converter.makeHtml(bubbleText)
    // Append new content to the existing chat bubble
    aiMessageBubble.innerHTML = html
  }

  onInputChange(files: FileList) {
    if (files.length > 0) {
      this.uploadImage(files)
    } else {
      console.error(files.length === 0 || "NO IMAGE UPLOADED")
      return false
    }
  }

  private uploadImage(files) {
    let newFile
    let tempImagesBase64List = []
    if (files.length > 10 || this.imagesBase64List.length > 10) {
      // this.showErrorMessage = true
      // console.error('You can upload a maximum of 10 images once at a time.');
      return
    }
    for (var i = 0; i < files.length; i++) {
      const mimeType = files[i].type
      if (!mimeType.match("image.*")) {
        console.log("file is not an image")
        return
      }
      newFile = files[i]

      const reader = new FileReader()

      reader.onload = () => {
        const imagePreviewContainer: HTMLElement = this.el.shadowRoot.querySelector("#previewContainer")

        const base64Image = `data:${mimeType};base64,${(reader.result as string).split(",")[1]}`
        this.imagesBase64List.push(base64Image)
        tempImagesBase64List = this.imagesBase64List

        const newDiv = document.createElement("div")
        newDiv.classList.add("image-Container")
        newDiv.classList.add("sc-ai12z-input-form")

        const img = document.createElement("img")
        img.setAttribute("src", reader.result as string)
        img.style.width = "70px"
        img.style.height = "50px"

        const deleteSpan = document.createElement("span")
        deleteSpan.textContent = "x"
        deleteSpan.classList.add("delete-image")
        deleteSpan.classList.add("sc-ai12z-input-form")
        imagePreviewContainer.appendChild(newDiv)

        newDiv.appendChild(img)
        newDiv.appendChild(deleteSpan)

        deleteSpan.onclick = function (event) {
          let imgSrc = event.target["previousSibling"] ? event.target["previousSibling"].src : null
          let index = tempImagesBase64List.indexOf(imgSrc)
          if (index > -1) {
            tempImagesBase64List.splice(index, 1)
          }
          newDiv.remove()
        }

        // console.log('uploading finished, emitting an image blob to the outside world');
      }
      reader.readAsDataURL(newFile)
      reader.onloadend = () => {
        console.log("upload finished")
      }

      reader.onerror = err => {
        console.error("something went wrong...", err)
      }
    }
  }

  getConversationHistory() {
    const storedData = localStorage.getItem(`${this.visitorID}`)
    return storedData ? JSON.parse(storedData) : []
  }

  saveConversation() {
    let pastMessages = this.getConversationHistory()
    // console.log("saving conversation", pastMessages)
    if (pastMessages.length > 0) {
      let conversationExists = pastMessages.filter(item => item.conversationId === this.conversationId && item.projectId === this.botSettings?.pId)
      if (conversationExists.length > 0) {
        conversationExists[0].messages = this.messages
      } else {
        pastMessages.push({
          conversationId: this.conversationId,
          projectId: this.botSettings?.pId,
          date: new Date(),
          messages: this.messages,
        })
      }
    } else {
      pastMessages.push({
        conversationId: this.conversationId,
        projectId: this.botSettings?.pId,
        date: new Date(),
        messages: this.messages,
      })
    }

    if (this.messages.length > 0) {
      localStorage.setItem(`${this.visitorID}`, JSON.stringify(pastMessages))
    }
  }

  loadConversation() {
    this.showWelcomeScreen = false
    this.hideInput = true
    // this.messages = []
    const storedMessages = localStorage.getItem(`${this.visitorID}`)
    if (storedMessages) {
      this.conversationHistory = JSON.parse(storedMessages)
      this.conversationHistory = this.conversationHistory.filter(item => item.projectId === this.botSettings?.pId)
      // console.log("conversationHistory", this.conversationHistory)
      // this.messages = chatHistory.map(item => ({ ...item }))
    }
  }

  @Listen("keydown")
  handleKeyDown(ev: KeyboardEvent) {
    if (ev.key === "Enter" && !ev.shiftKey) {
      // console.log("down arrow pressed")
      ev.preventDefault()
      if (this.inputEl?.value.trim().length > 0) {
        this.handleSend(this.inputEl.value)
      }
    }
  }

  startTimer() {
    // const startTime = Date.now()
    this.timer = setInterval(() => {
      this.questionCounter = 0
      // const endTime = Date.now()
      // console.log(`Timer executed after ${endTime - startTime} milliseconds`)
      localStorage.setItem(`ai12z-bot-data`, JSON.stringify({ qCounter: this.questionCounter }))
    }, this.botSettings.autoResetTimer)
  }

  updateScreenSize = () => {
    // console.log("updateScreenSize")

    if (window.innerWidth <= 767) {
      this.isMinimized = this.isOpened ? false : true
    }
    // if (window.innerWidth < 640) {
    //   this.isMinimized = this.isOpened ? false : true
    // } else if (window.innerWidth < 768) {
    //   this.isMinimized = this.isOpened ? false : true
    // } else {
    // console.log("content", this.isContent)
    // this.isMinimized = this.isExpanded ? false : true
    // this.isExpanded = true
    // }
  }

  handleSend = eleValue => {
    // console.log("handle send", eleValue)
    if (eleValue.trim().length === 0 && this.imagesBase64List.length === 0) {
      return
    }
    this.questionCounter = this.questionCounter + 1
    localStorage.setItem(`ai12z-bot-data`, JSON.stringify({ qCounter: this.questionCounter }))
    const inputValue = eleValue

    if (this.inputEl) {
      this.inputEl.value = inputValue
    }
    if (this.messages.length === 0 && this.botSettings.autoResetTimer > 0) {
      this.startTimer()
    }
    if (this.showWelcomeScreen && this.botSettings.botVersion === "v1") {
      this.showWelcomeScreen = false
    }

    if (this.messages.length === 0) {
      this.socketConnection()
    }

    // if (inputValue.trim()) {
    const now = new Date()
    const timestamp = now.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" })

    // Add the new message to the chat
    this.messages = [
      ...this.messages,
      {
        text: inputValue,
        isUser: true,
        id: `user-${generateUUID()}`,
        timestamp: timestamp,
        images: this.imagesBase64List,
        conversationId: this.conversationId,
        formModel: {},
        surveyDomId: "",
      },
      {
        text: this.botSettings.maxQuestion > 0 && this.questionCounter > this.botSettings.maxQuestion ? this.botSettings.msgLimit : "",
        isUser: false,
        id: `chatbot-${generateUUID()}`,
        timestamp: "",
        images: [],
        conversationId: this.conversationId,
        formModel: {},
        surveyDomId: "",
      },
    ]

    if (this.messages.length === 2) {
      this.visitorID = getOrCreateVisitorId()
    }

    this.checkHistory()

    setTimeout(() => {
      this.scrollToBottom()
    }, 100)
    if (this.botSettings.maxQuestion > 0 && this.questionCounter > this.botSettings.maxQuestion) {
      console.log("Max question limit reached")
      this.inputEl.value = ""
    } else {
      this.currentDomId = this.messages[this.messages.length - 1].id
      this.invokeSocket()
    }
    // this.invokeSocket()

    const parent = this.el.shadowRoot.querySelector("#previewContainer")
    if (parent) {
      parent.innerHTML = ""
    }

    this.imagesBase64List = []
    this.rowCount = 1
    this.showSubmit = false
    // }
  }

  scrollToBottom() {
    const container = this.el.shadowRoot.querySelector(".chat-body")
    if (container) {
      container.scroll({
        top: container.scrollHeight,
        behavior: "smooth",
      })
    }
  }

  defaultTemplate() {
    return (
      <div class={{ "prose": true, "floating-icon": !this.isBot, "right": this.botSettings?.botPosition === "right", "left": this.botSettings?.botPosition === "left" }}>
        <svg xmlns="http://www.w3.org/2000/svg" fill="white" height="30px" width="30px" version="1.1" id="Capa_1" viewBox="0 0 60.019 60.019">
          <g>
            <path d="M59.888,47.514l-3.839-11.518c2.056-3.615,3.14-7.716,3.14-11.893c0-13.286-10.809-24.095-24.095-24.095   c-8.242,0-15.824,4.223-20.219,11.007c3.089-1.291,6.477-2.007,10.029-2.007C39.294,9.01,51,20.716,51,35.104   c0,3.996-0.905,7.783-2.518,11.172l10.263,2.701c0.085,0.022,0.17,0.033,0.255,0.033c0.006,0,0.014-0.001,0.02,0   c0.553,0,1-0.448,1-1C60.019,47.829,59.972,47.66,59.888,47.514z" />
            <path d="M24.905,11.01C11.619,11.01,0.81,21.819,0.81,35.104c0,4.176,1.084,8.277,3.14,11.893L0.051,58.693   c-0.116,0.349-0.032,0.732,0.219,1C0.462,59.898,0.727,60.01,1,60.01c0.085,0,0.17-0.011,0.255-0.033l12.788-3.365   c3.35,1.694,7.097,2.587,10.862,2.587C38.191,59.199,49,48.39,49,35.104S38.191,11.01,24.905,11.01z M41.246,26.799   c-0.152,0.083-0.317,0.123-0.479,0.123c-0.354,0-0.696-0.188-0.878-0.519c-2.795-5.097-8.115-8.679-13.883-9.349   c-0.549-0.063-0.941-0.56-0.878-1.108c0.063-0.548,0.558-0.942,1.108-0.878c6.401,0.743,12.304,4.718,15.406,10.373   C41.908,25.926,41.73,26.534,41.246,26.799z" />
          </g>
        </svg>
      </div>
    )
  }

  handleFollowUp(_e) {
    // console.log("follow up", e)
    this.messages = [...[]]
    this.conversationId = ""
    this.showWelcomeScreen = true
  }

  showButton(e) {
    if (e.target.value.length > 0) {
      this.showSubmit = true
    } else {
      this.showSubmit = false
    }
  }

  toggleTextarea() {
    // console.log("toggleTextarea", this.showTextarea)
    this.showTextarea = false // Remove textarea
    setTimeout(() => {
      this.showTextarea = true // Re-add textarea after a short delay
      // console.log("toggleTextarea2", this.showTextarea)
    }, 50) // Small delay ensures the element is fully unmounted
  }
  render() {
    // const imageSrc = getAssetPath(`./assets/ai12z-bot/img/chatbot.jpg`)
    const style = {
      width: this.botSettings?.botWidth ?? "35%",
      height: this.botSettings?.botHeight ?? "80%",
    }

    if (!this.canRender) {
      return (
        <Host>
          <span style={{ display: "none" }}>Failed to load ai12z bot control due to insufficient fund</span>
        </Host>
      )
    }
    return (
      <div>
        {this.botSettings.botVersion === "v1" && (
          <div>
            <div
              class={{
                "right": this.botSettings?.botPosition === "right",
                "left": this.botSettings?.botPosition === "left",
                "custom-floating-icon ": this.isBot,
                "hide-chatbot": this.isChatOpen,
              }}
              onClick={() => this.action("open")}
            >
              {!this.isBot && this.botSettings?.botPosition && this.defaultTemplate()}
              {this.isBot && <slot name="bot" />}
            </div>
            {!this.isChatOpen && this.botSettings?.popover?.returnMessage && <bot-popover popoverConfig={this.botSettings?.popover}></bot-popover>}
            {this.isChatOpen && (
              <div
                class={{
                  "chat-window": true,
                  "chat-window-open": this.isChatOpen,
                  "chat-window-close": !this.isChatOpen,
                  "chat-right": this.botSettings?.botPosition === "right",
                  "chat-left": this.botSettings?.botPosition === "left",
                }}
                style={style}
              >
                {!this.hideInput && (
                  <div class="chat-header">
                    {this.botSettings?.buttons?.length > 0 && (
                      <button class="hamburger" onClick={e => this.toggleMenu(e)}>
                        &#9776; {/* Hamburger Icon */}
                      </button>
                    )}
                    <img class="avatar" src={this.botSettings?.botLogo ?? this.botlogo} alt="Avatar" />
                    <span class="chat-name">{this.botSettings?.botName}</span>
                    {this.showHistory && (
                      <button onClick={() => this.loadConversation()}>
                        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#ffffff" width="25" height="25">
                          <path fill="none" d="M0 0L24 0 24 24 0 24z"></path>{" "}
                          <path d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10c-1.702 0-3.305-.425-4.708-1.175L2 22l1.176-5.29C2.426 15.306 2 13.703 2 12 2 6.477 6.477 2 12 2zm0 2c-4.418 0-8 3.582-8 8 0 1.335.326 2.618.94 3.766l.35.654-.656 2.946 2.948-.654.653.349c1.148.614 2.43.939 3.765.939 4.418 0 8-3.582 8-8s-3.582-8-8-8zm1 3v5h4v2h-6V7h2z"></path>{" "}
                        </svg>
                      </button>
                    )}
                    <button class="minimizebtn" onClick={() => this.action("minimize")}>
                      <svg fill="white" height="20px" width="20px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512">
                        <path d="M505.752,6.248c-8.331-8.331-21.839-8.331-30.17,0L320,161.83V64c0-11.782-9.551-21.333-21.333-21.333 c-11.782,0-21.333,9.551-21.333,21.333v149.333c0,0.007,0.001,0.015,0.001,0.022c0.001,0.695,0.037,1.39,0.105,2.083 c0.031,0.318,0.091,0.627,0.136,0.94c0.054,0.375,0.098,0.75,0.171,1.122c0.071,0.359,0.17,0.708,0.259,1.061 c0.081,0.322,0.151,0.645,0.248,0.964c0.105,0.346,0.234,0.68,0.356,1.018c0.114,0.318,0.219,0.639,0.349,0.953 c0.131,0.316,0.284,0.618,0.43,0.926c0.152,0.323,0.296,0.649,0.465,0.966c0.158,0.295,0.338,0.575,0.509,0.861 c0.186,0.311,0.361,0.626,0.564,0.929c0.211,0.316,0.447,0.613,0.674,0.917c0.19,0.253,0.365,0.513,0.568,0.759 c0.892,1.087,1.889,2.085,2.977,2.977c0.246,0.202,0.506,0.378,0.759,0.568c0.304,0.228,0.601,0.463,0.917,0.674 c0.303,0.203,0.618,0.379,0.929,0.564c0.286,0.171,0.566,0.351,0.861,0.509c0.317,0.169,0.643,0.313,0.966,0.465 c0.308,0.145,0.611,0.299,0.926,0.43c0.314,0.13,0.635,0.235,0.953,0.349c0.338,0.122,0.672,0.251,1.018,0.356 c0.318,0.096,0.642,0.167,0.964,0.248c0.353,0.089,0.701,0.188,1.061,0.259c0.372,0.074,0.748,0.118,1.122,0.171 c0.314,0.045,0.622,0.104,0.94,0.136c0.693,0.068,1.388,0.105,2.083,0.105c0.007,0,0.015,0.001,0.022,0.001H448 c11.782,0,21.333-9.551,21.333-21.333c0-11.782-9.551-21.333-21.333-21.333h-97.83L505.752,36.418 C514.083,28.087,514.083,14.58,505.752,6.248z"></path>{" "}
                        <path d="M234.56,296.562c-0.031-0.318-0.091-0.627-0.136-0.94c-0.054-0.375-0.098-0.75-0.171-1.122 c-0.071-0.359-0.17-0.708-0.259-1.061c-0.081-0.322-0.151-0.645-0.248-0.964c-0.105-0.346-0.234-0.68-0.356-1.018 c-0.114-0.318-0.219-0.639-0.349-0.953c-0.131-0.316-0.284-0.618-0.43-0.926c-0.152-0.323-0.296-0.649-0.465-0.966 c-0.158-0.295-0.338-0.575-0.509-0.861c-0.186-0.311-0.361-0.626-0.564-0.929c-0.211-0.316-0.447-0.613-0.674-0.917 c-0.19-0.253-0.365-0.513-0.568-0.759c-0.892-1.087-1.889-2.085-2.977-2.977c-0.246-0.202-0.506-0.378-0.759-0.568 c-0.304-0.228-0.601-0.463-0.917-0.674c-0.303-0.203-0.618-0.379-0.929-0.564c-0.286-0.171-0.566-0.351-0.861-0.509 c-0.317-0.169-0.643-0.313-0.966-0.465c-0.308-0.145-0.611-0.299-0.926-0.43c-0.314-0.13-0.635-0.235-0.953-0.349 c-0.338-0.122-0.672-0.251-1.018-0.356c-0.318-0.096-0.642-0.167-0.964-0.248c-0.353-0.089-0.701-0.188-1.061-0.259 c-0.372-0.074-0.748-0.118-1.122-0.171c-0.314-0.045-0.622-0.104-0.94-0.136c-0.7-0.069-1.402-0.106-2.105-0.106l0,0H64 c-11.782,0-21.333,9.551-21.333,21.333C42.667,310.449,52.218,320,64,320h97.83L6.248,475.582c-8.331,8.331-8.331,21.839,0,30.17 c8.331,8.331,21.839,8.331,30.17,0L192,350.17V448c0,11.782,9.551,21.333,21.333,21.333c11.782,0,21.333-9.551,21.333-21.333 V298.667l0,0C234.667,297.964,234.629,297.262,234.56,296.562z"></path>{" "}
                      </svg>
                    </button>

                    <button class="close-btn" onClick={() => this.action("close")}>
                      <svg aria-hidden="true" width="25" height="13" viewBox="0 0 23 23" fill="none">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          fill="white"
                          d="M9.34583 11.2L0.384011 2.23818C-0.128004 1.72617 -0.128004 0.896026 0.384011 0.384011C0.896026 -0.128004 1.72617 -0.128004 2.23818 0.384011L11.2 9.34583L20.1618 0.384011C20.6738 -0.128004 21.504 -0.128004 22.016 0.384011C22.528 0.896026 22.528 1.72617 22.016 2.23818L13.0542 11.2L22.016 20.1618C22.528 20.6738 22.528 21.504 22.016 22.016C21.504 22.528 20.6738 22.528 20.1618 22.016L11.2 13.0542L2.23818 22.016C1.72617 22.528 0.896026 22.528 0.384011 22.016C-0.128003 21.504 -0.128003 20.6738 0.384011 20.1618L9.34583 11.2Z"
                        ></path>
                      </svg>
                    </button>
                  </div>
                )}
                <div class={`menu ${this.isMenuOpen ? "open" : "closed"}`} ref={el => (this.menuRef = el)}>
                  <ul>
                    {this.botSettings?.buttons?.map(item => (
                      <li
                        onClick={() => {
                          this.isMenuOpen = !this.isMenuOpen
                          this.query = item.action
                          this.handleSend(item.label)
                        }}
                      >
                        {item.label}
                      </li>
                    ))}
                  </ul>
                </div>
                {this.hideInput && (
                  <div class="chat-header">
                    <button
                      onClick={() => {
                        this.showWelcomeScreen = true
                        this.hideInput = false
                        this.checkHistory()
                      }}
                    >
                      <svg aria-hidden="true" width="20" height="20" viewBox="0 0 10 19">
                        <path
                          fill="#FFFFFF"
                          d="M9.70711 0.542893C10.0976 0.933418 10.0976 1.56658 9.70711 1.95711L2.41421 9.25L9.70711 16.5429C10.0976 16.9334 10.0976 17.5666 9.70711 17.9571C9.31658 18.3476 8.68342 18.3476 8.29289 17.9571L0.292893 9.95711C0.105357 9.76957 -4.04995e-07 9.51522 -3.93402e-07 9.25C-3.81809e-07 8.98478 0.105357 8.73043 0.292893 8.54289L8.29289 0.542893C8.68342 0.152369 9.31658 0.152369 9.70711 0.542893Z"
                          clip-rule="evenodd"
                          fill-rule="evenodd"
                        ></path>
                      </svg>
                    </button>
                    <span class="header-title">Conversation History</span>
                  </div>
                )}

                <div class="chat-body">
                  {this.showWelcomeScreen && (
                    <chatbot-welcome
                      welcomeMessage={this.botSettings?.welcome?.message}
                      buttonsList={this.botSettings?.welcome?.buttons || this.botSettings?.welcome?.welcomeButtons}
                      welcomelogo={this.botSettings?.welcome?.image}
                    />
                  )}
                  {this.showHistory && this.conversationHistory.length > 0 && this.hideInput && (
                    <chatbot-history chatList={this.conversationHistory} botName={this.botSettings?.botName}></chatbot-history>
                  )}
                  {!this.showWelcomeScreen && this.messages.length > 0 && <p class="timestamp">{this.timestamp}</p>}
                  {!this.showWelcomeScreen &&
                    this.messages.length > 0 &&
                    this.messages.map(msg => (
                      <div class={{ "message": true, "message-user": msg.isUser }}>
                        <div class={{ "msg-wrapper": true, "pl-1": true, "md:pl-0": true }}>
                          {!msg.isUser && <img class="bot-avatar hidden md:block" src={this.botSettings?.botAvatar ?? this.botAvatar} alt="Bot Avatar" />}
                          <div class={{ "message-content": true, "bubble-width": !msg.isUser }}>
                            <span class={{ "message-text": true, "message-bot": !msg.isUser, "prose": true, "p-2.5": true }} id={msg.id} innerHTML={msg.text}>
                              {msg?.images?.map(img => {
                                return <img src={img} class="thumbnail" alt="thumbnail" />
                              })}
                              {!msg.isUser && msg.text === "" && (
                                <svg class="animate-spin h-5 w-5 text-gray-400" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" id="spinner">
                                  <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                                  <path
                                    class="opacity-75"
                                    fill="currentColor"
                                    d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 0 1 4 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                                  ></path>
                                </svg>
                              )}
                            </span>
                            <span class="message-timestamp">{msg.timestamp}</span>
                          </div>
                        </div>
                      </div>
                    ))}
                </div>

                <div id="previewContainer"></div>

                {/* {!this.hideInput && (
              <div class="chat-footer">
                {this.messages.length === 0 && (
                  <div class="custom-privacy">
                    <slot name="custom-privacy" />
                  </div>
                )}
                {this.messages?.length > 0 && (
                  <div class="follow-up">
                    <input
                      ref={el => (this.followUpElem = el as HTMLInputElement)}
                      type="checkbox"
                      name="followUp"
                      id="followUp"
                      defaultChecked={true}
                      class="follow-up-input"
                      onChange={ev => this.handleFollowUp(ev)}
                    />
                    <label htmlFor="followUp">Do you have a follow up question?</label>
                    <svg
                      onClick={() => this.followUpElem.click()}
                      class="custom-svg-checkbox
                peer-checked:block text-white"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      stroke-width="4"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <polyline points="20 6 9 17 4 12"></polyline>
                    </svg>
                  </div>
                )}
                <div style={{ display: "flex" }}>
                  <textarea
                    rows={this.rowCount}
                    placeholder={this.botSettings?.botPlaceholderText ?? "Type your message..."}
                    ref={el => (this.inputEl = el as HTMLTextAreaElement)}
                    onKeyUp={this.adjustHeight}
                  />
                  {this.botSettings.imageUpload && (
                    <div class="custom-attachment">
                      <input
                        type="file"
                        multiple
                        name="files[]"
                        id="fileInput"
                        accept="image/*"
                        class="image-upload__input"
                        onChange={($event: any) => this.onInputChange($event.target.files)}
                        ref={el => (this.uploadElem = el as HTMLInputElement)}
                      />
                      <svg onClick={() => this.uploadElem.click()} aria-hidden="true" width="18" height="16" viewBox="0 0 16 18">
                        <path
                          fill="#687882"
                          fill-rule="evenodd"
                          d="M8.078 16a.71.71 0 0 1-.513-.222.784.784 0 0 1 0-1.075l7.53-7.879c.562-.587.871-1.368.871-2.199 0-.83-.31-1.611-.87-2.197a2.883 2.883 0 0 0-4.204 0l-8.735 9.139c-.493.516-.73 1.012-.703 1.476.026.452.298.801.46.968.27.284.563.402.892.358.413-.054.888-.35 1.375-.86l6.854-7.172a.703.703 0 0 1 1.026 0 .784.784 0 0 1 0 1.074l-6.853 7.172c-.728.761-1.475 1.196-2.222 1.293-.783.102-1.509-.172-2.1-.79-.528-.553-.841-1.246-.881-1.952-.053-.917.326-1.805 1.125-2.64l8.735-9.14a4.292 4.292 0 0 1 6.257 0 4.706 4.706 0 0 1 1.296 3.271c0 1.236-.461 2.4-1.296 3.274l-7.53 7.879a.71.71 0 0 1-.514.222z"
                        ></path>
                      </svg>
                    </div>
                  )}
                  <button onClick={() => this.handleSend(this.inputEl.value)}>
                    <svg aria-hidden="true" width="17" height="16" viewBox="0 0 17 16">
                      <path
                        fill="#687882"
                        fill-rule="evenodd"
                        stroke="#687882"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        d="M1 1l2.166 5.39 8.5 1.564-8.5 1.666L1 15l16-7z"
                      ></path>
                    </svg>
                  </button>
                </div>
              </div>
            )} */}
                <div class="ml-2">
                  {this.messages.length === 0 && (
                    <div class="custom-privacy">
                      <slot name="custom-privacy" />
                    </div>
                  )}
                  {this.messages?.length > 0 && (
                    <div class="follow-up">
                      <input
                        ref={el => (this.followUpElem = el as HTMLInputElement)}
                        type="checkbox"
                        name="followUp"
                        id="followUp"
                        defaultChecked={true}
                        class="follow-up-input"
                        onChange={ev => this.handleFollowUp(ev)}
                      />
                      <label htmlFor="followUp">Do you have a follow up question?</label>
                      <svg
                        onClick={() => this.followUpElem.click()}
                        class="custom-svg-checkbox
                  peer-checked:block text-white"
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        stroke-width="4"
                        stroke-linecap="round"
                        stroke-linejoin="round"
                      >
                        <polyline points="20 6 9 17 4 12"></polyline>
                      </svg>
                    </div>
                  )}
                </div>
                {!this.hideInput && (
                  <div class="chat-footer border-t border-gray-300">
                    <div class="flex items-center flex-row">
                      {this.botSettings?.imageUpload && (
                        <div class="relative inline-block" style={{ width: "5%" }}>
                          {/* Plus Button */}
                          {!this.hideAllButtons && (
                            <button class="w-8 h-8 text-blue-500" onClick={this.toggleBox}>
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="20" height="20">
                                <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"></path>
                              </svg>
                            </button>
                          )}

                          {/* Option Box */}
                          <div
                            class={`absolute bottom-12 left-0 w-44 bg-white rounded-lg shadow-lg transition-all duration-300 ease-in-out 
          ${this.isOpen ? "opacity-100 scale-100 pointer-events-auto" : "opacity-0 scale-90 pointer-events-none"}`}
                          >
                            <ul class="space-y-2">
                              {/* <li class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex">
                            <div class="mr-1">
                              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                                <path d="M12 9a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 9Z"></path>
                                <path
                                  fill-rule="evenodd"
                                  d="M9.344 3.071a49.52 49.52 0 0 1 5.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 0 0 1.11-.71l.822-1.315a2.942 2.942 0 0 1 2.332-1.39ZM6.75 12.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Zm12-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                                  clip-rule="evenodd"
                                ></path>
                              </svg>
                            </div>
                            <div>Capture</div>
                          </li> */}
                              <li
                                class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                                onClick={() => {
                                  this.uploadElem.click()
                                  this.isOpen = false
                                }}
                              >
                                <input
                                  type="file"
                                  multiple
                                  name="files[]"
                                  id="fileInput"
                                  accept="image/*"
                                  class="image-upload__input"
                                  onChange={($event: any) => this.onInputChange($event.target.files)}
                                  ref={el => (this.uploadElem = el as HTMLInputElement)}
                                />
                                <div class="mr-1">
                                  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 shrink-0">
                                    <path
                                      fill-rule="evenodd"
                                      clip-rule="evenodd"
                                      d="M18.0322 5.02393C17.7488 5.00078 17.3766 5 16.8 5H11.5002C11.3 6 11.0989 6.91141 10.8903 7.85409C10.7588 8.44955 10.6432 8.97304 10.3675 9.41399C10.1262 9.80009 9.80009 10.1262 9.41399 10.3675C8.97304 10.6432 8.44955 10.7588 7.85409 10.8903C7.81276 10.8994 7.77108 10.9086 7.72906 10.9179L5.21693 11.4762C5.1442 11.4924 5.07155 11.5001 5 11.5002V16.8C5 17.3766 5.00078 17.7488 5.02393 18.0322C5.04612 18.3038 5.0838 18.4045 5.109 18.454C5.20487 18.6422 5.35785 18.7951 5.54601 18.891C5.59546 18.9162 5.69617 18.9539 5.96784 18.9761C6.25118 18.9992 6.62345 19 7.2 19H10C10.5523 19 11 19.4477 11 20C11 20.5523 10.5523 21 10 21H7.16144C6.6343 21 6.17954 21 5.80497 20.9694C5.40963 20.9371 5.01641 20.8658 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3.13419 18.9836 3.06287 18.5904 3.03057 18.195C2.99997 17.8205 2.99998 17.3657 3 16.8385L3 11C3 8.92477 4.02755 6.93324 5.4804 5.4804C6.93324 4.02755 8.92477 3 11 3L16.8385 3C17.3657 2.99998 17.8205 2.99997 18.195 3.03057C18.5904 3.06287 18.9836 3.13419 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C20.8658 5.01641 20.9371 5.40963 20.9694 5.80497C21 6.17954 21 6.6343 21 7.16144V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V7.2C19 6.62345 18.9992 6.25118 18.9761 5.96784C18.9539 5.69617 18.9162 5.59546 18.891 5.54601C18.7951 5.35785 18.6422 5.20487 18.454 5.109C18.4045 5.0838 18.3038 5.04612 18.0322 5.02393ZM5.28014 9.41336L7.2952 8.96556C8.08861 8.78925 8.24308 8.74089 8.35381 8.67166C8.48251 8.59121 8.59121 8.48251 8.67166 8.35381C8.74089 8.24308 8.78925 8.08861 8.96556 7.2952L9.41336 5.28014C8.51014 5.59289 7.63524 6.15398 6.89461 6.89461C6.15398 7.63524 5.59289 8.51014 5.28014 9.41336ZM17 15C17 14.4477 17.4477 14 18 14C18.5523 14 19 14.4477 19 15V17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H19V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H17V15Z"
                                      fill="currentColor"
                                    ></path>
                                  </svg>
                                </div>
                                <div>Upload Images</div>
                              </li>
                            </ul>
                          </div>
                        </div>
                      )}
                      {/* Chat Input */}

                      {!this.hideAllButtons && (
                        <div style={{ width: "80%" }}>
                          <textarea
                            rows={this.rowCount}
                            placeholder={this.botSettings?.botPlaceholderText ?? "Type your message..."}
                            ref={el => (this.inputEl = el as HTMLTextAreaElement)}
                            onKeyUp={this.adjustHeight}
                            onFocus={e => this.showButton(e)}
                            class="flex-1 px-4 py-2 w-full focus:outline-none"
                          />
                        </div>
                      )}
                      <audio-recorder
                        component-type="bot"
                        onStartRecord={_ev => {
                          // console.log("test", _ev)
                          this.hideAllButtons = true
                        }}
                        onStopRecord={_ev => {
                          this.hideAllButtons = false
                        }}
                        onSendTranscript={ev => {
                          // console.log("ev", ev)

                          setTimeout(() => {
                            // console.log("input", this.inputEl)
                            if (this.inputEl) {
                              this.inputEl.value = ev.detail
                              this.adjustHeight()
                              this.showSubmit = true
                            }
                          }, 1000)
                        }}
                        style={{ width: this.hideAllButtons ? "100%" : "10%" }}
                      ></audio-recorder>
                      {/* )} */}
                      {!this.hideAllButtons && (
                        <div>
                          <button
                            class="relative w-10 h-10 flex items-center justify-center rounded-full transition-transform duration-300 ease-in-out bg-blue-500"
                            onClick={() => this.handleSend(this.inputEl.value)}
                          >
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="white" class="w-5 h-5">
                              <path
                                fill-rule="evenodd"
                                d="M8 14a.75.75 0 0 1-.75-.75V4.56L4.03 7.78a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.75 4.56v8.69A.75.75 0 0 1 8 14Z"
                                clip-rule="evenodd"
                              ></path>
                            </svg>
                          </button>
                        </div>
                      )}
                      {/* {!this.showSubmit && !this.hideAllButtons && (
                    <div>
                      <button class="relative w-10 h-10 flex items-center justify-center rounded-full transition-transform duration-300 ease-in-out bg-blue-500">
                        <svg aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="white" viewBox="0 0 24 24" stroke-width="0" stroke="currentColor" width="20" height="20">
                          <path
                            fill-rule="evenodd"
                            d="M12 5a7 7 0 0 0-7 7v1.17c.313-.11.65-.17 1-.17h2a1 1 0 0 1 1 1v6a1 1 0 0 1-1 1H6a3 3 0 0 1-3-3v-6a9 9 0 0 1 18 0v6a3 3 0 0 1-3 3h-2a1 1 0 0 1-1-1v-6a1 1 0 0 1 1-1h2c.35 0 .687.06 1 .17V12a7 7 0 0 0-7-7Z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </button>
                    </div>
                  )} */}
                    </div>
                  </div>
                )}
              </div>
            )}
          </div>
        )}
        {this.botSettings.botVersion !== "v1" && this.isRendered && (
          <div
            class={`pt-0 show-grid  ${this.isAnimated ? "transition ease-out duration-300" : ""} layout ${this.isOpened ? "is-open" : ""} ${this.isExpanded ? "is-expanded" : ""} search-flex`}
            style={{
              gridTemplateColumns: `0fr minmax(${this.botSettings.minWidth ?? "340px"}, ${this.botSettings.maxWidth ?? "375px"}) 0fr`,
              paddingTop: this.botSettings?.paddingTop ?? "96px",
            }}
          >
            <div
              class={`modal-overlay`}
              role="button"
              aria-label="Close Modal"
              style={{
                display: this.isExpanded && this.isOpened ? "grid" : "none",
                opacity: this.isExpanded && this.isOpened ? "1" : "0",
                pointerEvents: this.isExpanded && this.isOpened ? "all" : "none",
              }}
            ></div>
            {/* {this.isOpen && ( */}
            <div
              class="modal"
              data-testid="modal"
              aria-hidden="false"
              role="dialog"
              aria-modal="true"
              tabindex="-1"
              style={{ display: this.isOpened ? "grid" : "none", opacity: this.isOpened ? "1" : "0", transform: this.isOpened ? "none" : "translateY(100%)" }}
            >
              <div class="flex bg-white overflow-hidden border-b border-gray-90 border-solid md:pl-3 pl-4 justify-end md:rounded-t-xl items-center toolbar">
                <div class="flex gap-1 toolbar-overflow-actions">
                  {!this.showHistory && (
                    <button
                      class="rounded-full flex items-center justify-center disabled:cursor-not-allowed bg-transparent hover:bg-blue-95 disabled:bg-transparent disabled:hover:bg-transparent h-6 w-6"
                      tabindex="0"
                      aria-label="options menu"
                      aria-haspopup="menu"
                      aria-expanded="false"
                      aria-controls="toolbar-dropdown-menu"
                      onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        this.toggleBot(e)
                      }}
                    >
                      <i class="block wes-icon--loading text-body2 modal-toolbar-icon ">
                        <svg viewBox="0 0 24 24" id="align-left-2" data-name="Flat Line" xmlns="http://www.w3.org/2000/svg" class="icon flat-line" fill="currentColor">
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <path id="primary" d="M3,12H17M3,6H21M3,18H13" style={{ fill: "none", stroke: "currentColor" }}></path>
                          </g>
                        </svg>
                      </i>
                    </button>
                  )}
                  {this.showHistory && (
                    <button
                      class="w-6 h-6 back-btn"
                      onClick={e => {
                        e.preventDefault()
                        e.stopPropagation()
                        this.showHistory = false
                        this.showWelcomeScreen = true
                        this.hideInput = false
                        this.isOpened = true
                        this.isMinimized = false
                        this.isAnimated = true
                      }}
                    >
                      <i>
                        <svg viewBox="0 0 200 200" data-name="Layer 1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" width="20" height="20">
                          <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                          <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                          <g id="SVGRepo_iconCarrier">
                            <title></title>
                            <path d="M160,89.75H56l53-53a9.67,9.67,0,0,0,0-14,9.67,9.67,0,0,0-14,0l-56,56a30.18,30.18,0,0,0-8.5,18.5c0,1-.5,1.5-.5,2.5a6.34,6.34,0,0,0,.5,3,31.47,31.47,0,0,0,8.5,18.5l56,56a9.9,9.9,0,0,0,14-14l-52.5-53.5H160a10,10,0,0,0,0-20Z"></path>
                          </g>
                        </svg>
                      </i>
                    </button>
                  )}

                  <div
                    id="dropdown-menu"
                    role="menu"
                    class={`flex flex-col gap-y-1 grow-wrap absolute bg-white border-b border-gray-80 border-solid rounded-lg shadow-lg p-2 mt-4 min-w-[200px] left-5 overflow-hidden ${this.isToggled ? "show" : ""} dropdown-menu`}
                    style={{ height: "auto" }}
                    ref={el => (this.menuV2Ref = el)}
                  >
                    {this.botSettings?.buttons?.map(button => (
                      <div class="w-full dropdown-item" role="menuitem" tabindex="-1">
                        <button
                          class="dropdown-item-button"
                          onClick={e => {
                            this.toggleBot(e)
                            this.showHistory = false
                            this.showWelcomeScreen = true
                            this.handleSend(button.label)
                          }}
                        >
                          {button.label}
                        </button>
                      </div>
                    ))}
                    <div class="w-full dropdown-item" role="menuitem" tabindex="-1">
                      <button
                        class="dropdown-item-button"
                        onClick={e => {
                          this.toggleBot(e)
                          this.showHistory = true
                          // this.hideInput = true
                          this.loadConversation()
                          // console.log("this.show", this.conversationHistory)
                        }}
                      >
                        View Recent chat
                      </button>
                    </div>
                    <div class="w-full dropdown-item" role="menuitem" tabindex="-1">
                      <button
                        class="dropdown-item-button"
                        onClick={ev => {
                          ev.preventDefault()
                          this.messages = [...[]]
                          this.conversationId = ""
                          this.isOpened = false
                          this.isMinimized = this.isExpanded ? false : true
                          this.showWelcomeScreen = true
                          this.toggleBot(ev)
                          this.showHistory = false
                          this.close.emit("close")
                        }}
                      >
                        End conversation
                      </button>
                    </div>
                  </div>
                </div>
                {this.botSettings?.botLogo && <img src={this.botSettings?.botLogo} class="w-8 h-8 rounded-lg"></img>}
                <h2 class="flex-1 pl-2 heading text-body1">{this.botSettings?.botName}</h2>
                <div class="buttons flex gap-2 p-[10px]">
                  <button
                    class="rounded-full flex items-center justify-center disabled:cursor-not-allowed bg-transparent hover:bg-blue-95 disabled:bg-transparent disabled:hover:bg-transparent h-6 w-6 hidden md:flex"
                    tabindex="0"
                    onClick={() => {
                      this.isExpanded = !this.isExpanded
                      this.isAnimated = true
                    }}
                    aria-label="Collapse Agentforce to Side Panel"
                  >
                    <i class="wes-block wes-icon--loading wes-text-body2 modal-toolbar-icon">
                      {this.isExpanded && (
                        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M18.215 14.7076H27.692C28.3074 14.7076 28.492 14.0307 27.9997 13.5383L24.9843 10.4614L30.5228 4.86149C30.8305 4.5538 30.8305 3.99995 30.5228 3.69226L28.2459 1.41536C27.9382 1.16921 27.4459 1.16921 27.0767 1.4769L21.5381 7.01532L18.3997 3.99995C17.9073 3.50765 17.2304 3.69226 17.2304 4.30764V13.7845C17.2304 14.2153 17.7843 14.7076 18.215 14.7076ZM13.7847 17.2308H4.30766C3.69227 17.2308 3.50765 17.9077 3.99996 18.4L7.01537 21.4769L1.47686 27.0769C1.16917 27.3846 1.16917 27.9384 1.47686 28.2461L3.75381 30.523C4.0615 30.8307 4.55381 30.8307 4.92305 30.523L10.5231 24.923L13.6616 27.9384C14.0924 28.4923 14.7693 28.3076 14.7693 27.6923V18.2769C14.7693 17.8462 14.2154 17.2308 13.7847 17.2308Z"
                          ></path>
                        </svg>
                      )}
                      {!this.isExpanded && (
                        <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                          <path
                            fill-rule="evenodd"
                            clip-rule="evenodd"
                            d="M30.0308 1.23071H20.4923C19.8769 1.23071 19.6923 1.78455 20.1846 2.27686L23.2 5.29222L17.6615 10.8306C17.3538 11.1383 17.3538 11.6306 17.6615 11.9999L19.9384 14.2768C20.2461 14.5845 20.7384 14.5845 21.1077 14.2768L26.7077 8.67681L29.7231 11.6922C30.2154 12.1845 30.7692 11.9999 30.7692 11.3845V1.90763C30.7692 1.5384 30.4 1.23071 30.0308 1.23071ZM2.15379 30.7692H11.6307C12.2461 30.7692 12.4307 30.0923 11.9384 29.6L8.92303 26.5231L14.4615 20.9231C14.7692 20.6154 14.7692 20.0616 14.4615 19.7539L12.1846 17.477C11.8769 17.1693 11.3846 17.1693 11.0153 17.477L5.47687 23.0154L2.39995 20C1.8461 19.5077 1.23071 19.6923 1.23071 20.3077V29.7846C1.23071 30.2153 1.72302 30.7692 2.15379 30.7692Z"
                          ></path>
                        </svg>
                      )}
                    </i>
                  </button>
                  <button
                    class="rounded-full flex items-center justify-center disabled:cursor-not-allowed bg-transparent hover:bg-blue-95 disabled:bg-transparent disabled:hover:bg-transparent h-6 w-6"
                    tabindex="0"
                    data-testid="modal-minimize"
                    aria-label="Minimize"
                    onClick={() => {
                      this.isOpened = false
                      // this.isContent = false
                      this.isContent = this.isExpanded && this.botSettings.isExpanded ? true : false
                      this.isMinimized = this.isExpanded && this.botSettings.isExpanded ? false : true
                      this.isAnimated = false
                      this.updateScreenSize()
                      this.minimize.emit("minimize")
                    }}
                  >
                    <i class="block wes-icon--loading text-body2 modal-toolbar-icon">
                      <svg viewBox="0 0 26 26" xmlns="http://www.w3.org/2000/svg" fill="currentColor">
                        <path
                          fill-rule="evenodd"
                          clip-rule="evenodd"
                          d="M25 24.25C25 24.65 24.65 25 24.25 25H1.75C1.35 25 1 24.65 1 24.25V22.75C1 22.35 1.35 22 1.75 22H24.25C24.65 22 25 22.35 25 22.75V24.25Z"
                        ></path>
                      </svg>
                    </i>
                  </button>
                </div>
              </div>
              <div class="flex-1 flex flex-col main">
                <div class="h-full flex flex-col chat-body">
                  <div class="px-5 flex-[1_1_0] min-h-[calc(100%-1px)] flex flex-col gap-y-3 @md:px-3 messages-container" role="region" aria-label="messages">
                    {/* <h3 class="text-display5 font-avant-garde text-[#001E5B] @md:text-display4 text-center @md:px-6 pb-3 @md:pb-7 @md:pt-8 pt-5">
                  How can <strong class="text-[#0344D1]">Agentforce</strong> help?
                </h3> */}
                    {this.showWelcomeScreen && <div class="@md:px-6 pb-3 @md:pb-7 @md:pt-8 pt-5 text-display5" innerHTML={this.botSettings?.welcome?.message}></div>}
                    {/* <div class="message-item flex pb-3 gap-x-2 @md:gap-x-3 justify-center" style={{ opacity: "1", transform: "none" }}>
                  <div class="flex flex-col">
                    <div class="timestamp text-gray-30 text-body4 pt-2">Agentforce joined • 12:45 PM</div>
                  </div>
                </div> */}
                    {this.messages.length > 0 &&
                      !this.showHistory &&
                      this.messages.map((message, _idx) => {
                        // const showAvatar = !message.isUser && (idx === this.messages.length - 1 || this.messages[idx + 1]?.isUser === true)

                        return (
                          <div
                            class={`flex pb-3 gap-x-2 @md:gap-x-3 
                  ${message.isUser ? "self-end" : ""}
                  ${message.isUser ? "justify-end" : ""} end-user-message message-item`}
                            style={{ opacity: "1", transform: "none" }}
                          >
                            {message.isUser && (
                              <div class="flex flex-col items-end">
                                <div
                                  data-testid="message"
                                  class="break-words @md:text-body2 box-border @md:pr-4 flex-1 rounded-lg py-2 px-4 user-msg text-body3"
                                  innerHTML={message.text}
                                >
                                  {message?.images?.map(img => {
                                    return <img src={img} class="thumbnail" alt="thumbnail" />
                                  })}
                                </div>

                                <div class="text-gray-30 pt-2 text-right text-body4">Sent {message.timestamp}</div>
                              </div>
                            )}
                            {!message.isUser && (
                              <div class="avatar-column">
                                <div role="img" aria-label="Agentforce said: " class="rounded-full h-6 w-6 p-2 grid bg-blue place-content-center">
                                  {this.botSettings.botAvatar && <img src={this.botSettings.botAvatar} class="w-8 h-8 rounded-full"></img>}
                                  {!this.botSettings.botAvatar && (
                                    // <i class="_wes-icon_9ngz3_1 block text-body1" style={{ color: "rgb(2, 80, 217)" }}>
                                    //   <svg viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" width={20} height={20}>
                                    //     <path d="M19.3786 16.9969H19.3909C18.8863 17.04 18.437 17.1262 18.0493 17.2492C18.0493 17.2492 17.4832 17.4277 16.6155 17.5508C16.4124 17.5816 16.154 17.5816 16.0124 17.5816H15.9078C15.7663 17.5816 15.5017 17.5692 15.3047 17.5385C14.437 17.3969 13.877 17.2 13.877 17.2C13.4893 17.0769 13.0401 16.9846 12.5355 16.9292C9.77243 16.6462 8.57858 17.6985 8.51089 17.8954C8.4432 18.0923 8.74473 20.6523 8.96627 21.0585C9.18166 21.4585 9.51396 21.6923 9.8155 21.8216C10.1232 21.9508 12.6524 22.2031 13.4955 22.0862C14.3386 21.9692 14.4678 21.6862 14.6955 21.2554C14.8555 20.9477 15.2678 19.5569 15.4955 18.7385C15.5509 18.5785 15.557 18.2585 15.9447 18.2339C16.3324 18.2646 16.3386 18.5908 16.3878 18.7508C16.6093 19.5692 16.997 20.9723 17.1509 21.28C17.3663 21.7169 17.4955 22 18.3386 22.1354C19.1755 22.2646 21.7109 22.0616 22.0186 21.9385C22.3263 21.8154 22.6586 21.5877 22.8801 21.1877C23.1017 20.7877 23.4463 18.2339 23.3847 18.0369C23.3232 17.8339 22.1478 16.7631 19.3786 16.9969Z"></path>
                                    //     <path d="M28.0124 8.95386H28.0186C27.2494 7.9754 26.3386 7.10771 25.3294 6.36309C26.3755 6.17848 27.1694 5.26771 27.1694 4.17232C27.1694 2.94155 26.1724 1.93848 24.9355 1.93848C23.6986 1.93848 22.7017 2.9354 22.7017 4.17232C22.7017 4.41848 22.7509 4.65232 22.8247 4.87386C21.237 4.12309 19.5017 3.63078 17.6863 3.44002C14.6463 3.12002 11.7109 3.66155 9.18166 4.8554C9.24935 4.64001 9.29858 4.41232 9.29858 4.17232C9.29858 2.94155 8.30166 1.93848 7.06473 1.93848C5.82781 1.93848 4.83089 2.9354 4.83089 4.17232C4.83089 5.26771 5.61858 6.17232 6.65243 6.36309C3.78473 8.48001 1.78473 11.5631 1.32935 15.1385C0.904735 18.4431 1.84627 21.7539 3.98781 24.4616C6.41243 27.5262 10.1786 29.5385 14.314 29.9754C14.8924 30.0369 15.4647 30.0677 16.0309 30.0677C23.4094 30.0677 29.797 25.0585 30.6709 18.2769C31.0955 14.9723 30.154 11.6616 28.0124 8.95386ZM16.0124 26.2523H16.0063C10.4555 26.2462 5.93858 22.5416 5.93858 17.9877C5.93858 16.6154 6.35704 15.2985 7.11397 14.1292C7.18166 14.5477 7.30473 14.9108 7.44012 15.1816C7.62473 15.5508 7.99397 15.7662 8.38166 15.7662C8.5355 15.7662 8.6955 15.7354 8.8432 15.6616C9.36627 15.4092 9.58166 14.7816 9.34166 14.2585C9.21243 13.9816 8.88012 13.0646 9.68627 12.3631C10.4678 13.0708 11.5878 13.9016 12.8493 14.3077C15.2001 15.0523 16.9786 14.6154 17.0524 14.5969C17.4093 14.5046 17.6863 14.24 17.797 13.8892C17.9078 13.5385 17.8278 13.1569 17.5878 12.8862C16.4001 11.52 15.834 10.5231 15.5878 9.92002C20.4001 10.5723 21.3232 14.4062 21.3601 14.5785C21.4647 15.0708 21.9017 15.4092 22.3878 15.4092C22.4617 15.4092 22.5294 15.4031 22.6032 15.3846C23.1755 15.2677 23.5386 14.7077 23.4217 14.1354C23.274 13.4216 22.8863 12.4554 22.197 11.4892C24.554 13.0031 26.0801 15.3539 26.0801 17.9939C26.0801 22.5477 21.5632 26.2523 16.0124 26.2523Z"></path>
                                    //   </svg>
                                    // </i>
                                    <i class="block text-body1 default-botAvatar">
                                      <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 16 16" height={20} width={20} xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8 1a5 5 0 0 0-5 5v1h1a1 1 0 0 1 1 1v3a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V6a6 6 0 1 1 12 0v6a2.5 2.5 0 0 1-2.5 2.5H9.366a1 1 0 0 1-.866.5h-1a1 1 0 1 1 0-2h1a1 1 0 0 1 .866.5H11.5A1.5 1.5 0 0 0 13 12h-1a1 1 0 0 1-1-1V8a1 1 0 0 1 1-1h1V6a5 5 0 0 0-5-5"></path>
                                      </svg>
                                    </i>
                                  )}
                                </div>
                              </div>
                            )}
                            {!message.isUser && (
                              <div class="flex flex-col" style={{ width: "100%" }}>
                                <div
                                  data-testid="message"
                                  class="prose max-w-full break-words @md:text-body2 box-border @md:pr-4 flex-1 rounded-lg text-gray-30 pr-2 text-body3"
                                  innerHTML={message.text}
                                  id={message.id}
                                >
                                  {message.text === "" && (
                                    <div class="w-full rounded-md" id="spinner">
                                      <div class="flex animate-pulse space-x-4">
                                        {/* <div class="size-10 rounded-full bg-gray-200"></div> */}
                                        <div class="flex-1 space-y-3 py-1">
                                          <div class="h-4 rounded bg-gray-200"></div>
                                          <div class="space-y-3">
                                            <div class="grid grid-cols-3 gap-4">
                                              <div class="col-span-2 h-4 rounded bg-gray-200"></div>
                                              <div class="col-span-1 h-4 rounded bg-gray-200"></div>
                                            </div>
                                            <div class="h-4 rounded bg-gray-200"></div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  )}
                                </div>
                                <div class="text-gray-30 pt-2 text-body4">
                                  {this.botSettings.botName} • {message.timestamp}
                                </div>
                              </div>
                            )}
                          </div>
                        )
                      })}
                    {this.showHistory && (
                      <chatbot-history chatList={this.conversationHistory} botName={this.botSettings?.botName} styles={this.customStyle} scripts={this.customJS}></chatbot-history>
                    )}
                    <div class="h-px pt-2px" style={{ overflowAnchor: "auto" }}></div>
                  </div>

                  <div aria-live="polite" class="absolute w-[1px] h-[1px] p-0 m-[-1px] overflow-hidden whitespace-nowrap border-0"></div>
                </div>
              </div>
            </div>
            {/* )} */}
            {/* {!this.isMinimized && ( */}
            <form
              data-testid="user-input"
              class={`relative pointer-events-auto ${this.isOpened ? "p-2.5" : ""} searchform user-input`}
              role="region"
              aria-label="Message Area"
              aria-hidden="false"
              style={{ opacity: !this.isMinimized ? "1" : "0", transform: "translateX(0)", pointerEvents: !this.isMinimized ? "auto" : "none" }}
            >
              {!this.isOpened && (
                <div class={`absolute right-4 md:right-0 border-2 border-white border-solid rounded-full ${this.isContent ? "" : "top-0"} minimize-input`}>
                  <button
                    class="rounded-full flex items-center justify-center disabled:cursor-not-allowed bg-gray-500 bg-opacity-60 hover:bg-opacity-80 h-5 w-5"
                    tabindex="0"
                    onClick={e => {
                      e.preventDefault()
                      this.isMinimized = !this.isMinimized
                    }}
                  >
                    <i class="block ai-minimize-icon ai-text-caption">
                      <svg xmlns="http://www.w3.org/2000/svg" height="52" width="52" viewBox="0 0 520 520" fill="#fff">
                        <path d="M500 275c0 8-7 15-15 15H35c-8 0-15-7-15-15v-30c0-8 7-15 15-15h450c8 0 15 7 15 15z"></path>
                      </svg>
                    </i>
                  </button>
                </div>
              )}
              <fieldset class={`flex flex-col  @md:mx-0 @md:rounded-t-xl  transition-colors ${this.isMinimized && !this.isExpanded ? "" : "p-4 user-input-fieldset"}`}>
                {/* <div class={`text-white wes-text-display7 pb-3 help-text ${this.isOpen ? "hide-title" : ""}`} aria-hidden="true">
              Need help? Ask AI.
            </div> */}
                {!this.isExpanded && this.isOpened && this.messages.length === 0 && (
                  <privacy-modal show={this.showPrivacy} message={this.botSettings.privacyTemplate}></privacy-modal>
                )}
                <div class="flex-1 align-bottom">
                  <div class="grow-wrap show-grid after:whitespace-pre-wrap after:invisible relative" data-replicated-value="" aria-disabled="false">
                    {this.botSettings.imageUpload && (
                      <div
                        aria-disabled="true"
                        class={`absolute flex items-center left-0 bottom-0 h-full pl-4 pr-2 ${this.hideAllButtons ? "hidden" : ""} ${this.isContent ? "hidden" : ""} agent-input-icon`}
                      >
                        <button
                          class="plus-icon"
                          onClick={e => {
                            e.stopPropagation()
                            e.preventDefault()
                            this.showMenu = !this.showMenu
                          }}
                        >
                          <i class="plus-icon wes-block wes-text-body1">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor" width="20" height="20">
                              <path d="M10.75 4.75a.75.75 0 0 0-1.5 0v4.5h-4.5a.75.75 0 0 0 0 1.5h4.5v4.5a.75.75 0 0 0 1.5 0v-4.5h4.5a.75.75 0 0 0 0-1.5h-4.5v-4.5Z"></path>
                            </svg>
                          </i>
                        </button>
                        {/* Option Box */}
                        <div
                          class={`absolute bottom-6 left-0 w-44 bg-white rounded-lg shadow-lg transition-all duration-300 ease-in-out z-10
            ${this.showMenu ? "opacity-100 scale-100 pointer-events-auto" : "opacity-0 scale-90 pointer-events-none"}`}
                        >
                          <ul class="space-y-2" ref={el => (this.plusIconRef = el)}>
                            <li
                              class="px-4 py-2 hover:bg-gray-100 cursor-pointer flex"
                              onClick={() => {
                                this.uploadElem.click()
                                this.isOpen = false
                                this.showMenu = false
                              }}
                            >
                              <input
                                type="file"
                                multiple
                                name="files[]"
                                id="fileInput"
                                accept="image/*"
                                class="image-upload__input"
                                onChange={($event: any) => {
                                  // this.isImage = true
                                  this.onInputChange($event.target.files)
                                }}
                                ref={el => (this.uploadElem = el as HTMLInputElement)}
                              />
                              <div class="mr-1">
                                <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 shrink-0">
                                  <path
                                    fill-rule="evenodd"
                                    clip-rule="evenodd"
                                    d="M18.0322 5.02393C17.7488 5.00078 17.3766 5 16.8 5H11.5002C11.3 6 11.0989 6.91141 10.8903 7.85409C10.7588 8.44955 10.6432 8.97304 10.3675 9.41399C10.1262 9.80009 9.80009 10.1262 9.41399 10.3675C8.97304 10.6432 8.44955 10.7588 7.85409 10.8903C7.81276 10.8994 7.77108 10.9086 7.72906 10.9179L5.21693 11.4762C5.1442 11.4924 5.07155 11.5001 5 11.5002V16.8C5 17.3766 5.00078 17.7488 5.02393 18.0322C5.04612 18.3038 5.0838 18.4045 5.109 18.454C5.20487 18.6422 5.35785 18.7951 5.54601 18.891C5.59546 18.9162 5.69617 18.9539 5.96784 18.9761C6.25118 18.9992 6.62345 19 7.2 19H10C10.5523 19 11 19.4477 11 20C11 20.5523 10.5523 21 10 21H7.16144C6.6343 21 6.17954 21 5.80497 20.9694C5.40963 20.9371 5.01641 20.8658 4.63803 20.673C4.07354 20.3854 3.6146 19.9265 3.32698 19.362C3.13419 18.9836 3.06287 18.5904 3.03057 18.195C2.99997 17.8205 2.99998 17.3657 3 16.8385L3 11C3 8.92477 4.02755 6.93324 5.4804 5.4804C6.93324 4.02755 8.92477 3 11 3L16.8385 3C17.3657 2.99998 17.8205 2.99997 18.195 3.03057C18.5904 3.06287 18.9836 3.13419 19.362 3.32698C19.9265 3.6146 20.3854 4.07354 20.673 4.63803C20.8658 5.01641 20.9371 5.40963 20.9694 5.80497C21 6.17954 21 6.6343 21 7.16144V10C21 10.5523 20.5523 11 20 11C19.4477 11 19 10.5523 19 10V7.2C19 6.62345 18.9992 6.25118 18.9761 5.96784C18.9539 5.69617 18.9162 5.59546 18.891 5.54601C18.7951 5.35785 18.6422 5.20487 18.454 5.109C18.4045 5.0838 18.3038 5.04612 18.0322 5.02393ZM5.28014 9.41336L7.2952 8.96556C8.08861 8.78925 8.24308 8.74089 8.35381 8.67166C8.48251 8.59121 8.59121 8.48251 8.67166 8.35381C8.74089 8.24308 8.78925 8.08861 8.96556 7.2952L9.41336 5.28014C8.51014 5.59289 7.63524 6.15398 6.89461 6.89461C6.15398 7.63524 5.59289 8.51014 5.28014 9.41336ZM17 15C17 14.4477 17.4477 14 18 14C18.5523 14 19 14.4477 19 15V17H21C21.5523 17 22 17.4477 22 18C22 18.5523 21.5523 19 21 19H19V21C19 21.5523 18.5523 22 18 22C17.4477 22 17 21.5523 17 21V19H15C14.4477 19 14 18.5523 14 18C14 17.4477 14.4477 17 15 17H17V15Z"
                                    fill="currentColor"
                                  ></path>
                                </svg>
                              </div>
                              <div>Upload Images</div>
                            </li>

                            {/* <li
                      class="px-4 pb-2 hover:bg-gray-100 cursor-pointer flex"
                      onClick={() => {
                        // this.captureScreen()
                        // this.toggleBox()
                        this.showMenu = !this.showMenu
                      }}
                    >
                      <div class="mr-1 mt-px">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
                          <path d="M12 9a3.75 3.75 0 1 0 0 7.5A3.75 3.75 0 0 0 12 9Z"></path>
                          <path
                            fill-rule="evenodd"
                            d="M9.344 3.071a49.52 49.52 0 0 1 5.312 0c.967.052 1.83.585 2.332 1.39l.821 1.317c.24.383.645.643 1.11.71.386.054.77.113 1.152.177 1.432.239 2.429 1.493 2.429 2.909V18a3 3 0 0 1-3 3h-15a3 3 0 0 1-3-3V9.574c0-1.416.997-2.67 2.429-2.909.382-.064.766-.123 1.151-.178a1.56 1.56 0 0 0 1.11-.71l.822-1.315a2.942 2.942 0 0 1 2.332-1.39ZM6.75 12.75a5.25 5.25 0 1 1 10.5 0 5.25 5.25 0 0 1-10.5 0Zm12-1.5a.75.75 0 1 0 0-1.5.75.75 0 0 0 0 1.5Z"
                            clip-rule="evenodd"
                          ></path>
                        </svg>
                      </div>
                      <div>Capture</div>
                    </li> */}
                          </ul>
                        </div>
                      </div>
                    )}
                    <div class={`${this.isContent ? "hidden" : ""} textarea`}>
                      <div id="previewContainer"></div>
                      {this.showTextarea && (
                        <textarea
                          class={`resize-none overflow-hidden text-ellipsis focus:outline-none w-full ${this.hideAllButtons ? "hidden" : ""}`}
                          data-testid="user-input-textarea"
                          rows={this.rowCount}
                          name="userMessage"
                          placeholder={this.botSettings?.botPlaceholderText ?? "Ask me anything"}
                          // aria-labelledby="message-submit"
                          ref={el => (this.inputEl = el as HTMLTextAreaElement)}
                          onKeyUp={_e => {
                            this.adjustHeight()
                          }}
                          onKeyDown={e => {
                            this.handleKeyDown(e)
                            if (e.key === "Enter" && !e.shiftKey) {
                              this.isOpened = true
                            }
                          }}
                        ></textarea>
                      )}
                    </div>
                    {this.botSettings.enableMic && (
                      <label class={`absolute bottom-0 ${this.isContent ? "hidden" : ""} ${this.hideAllButtons ? "w-full" : "right-8"}`}>
                        <audio-recorder
                          component-type="bot"
                          onStartRecord={_ev => {
                            // console.log("test", ev)
                            this.hideAllButtons = true
                          }}
                          onStopRecord={_ev => {
                            this.hideAllButtons = false
                          }}
                          onSendTranscript={ev => {
                            // console.log("ev", ev)

                            setTimeout(() => {
                              // console.log("input", this.inputEl)
                              if (this.inputEl) {
                                this.inputEl.value = ev.detail
                                this.adjustHeight()
                                this.showSubmit = true
                              }
                            }, 1000)
                          }}
                          style={{ width: this.hideAllButtons ? "100%" : "10%" }}
                        ></audio-recorder>
                      </label>
                    )}
                    <label class={`absolute right-0 bottom-0 ${this.isContent ? "hidden" : ""} ${this.hideAllButtons ? "hidden" : ""}`}>
                      <button
                        class="text-white transition rounded-full p-1.5 self-center btn-bg-color"
                        // class="rounded-full flex items-center justify-center disabled:cursor-not-allowed bg-transparent hover:bg-blue-95 disabled:bg-transparent disabled:hover:bg-transparent h-8 w-8"
                        tabindex="-1"
                        id="message-submit"
                        // type="submit"
                        onClick={e => {
                          e.preventDefault()
                          if ((!this.inputEl || this.inputEl.value.trim() === "") && this.imagesBase64List && this.imagesBase64List.length === 0) {
                            return
                          }
                          this.isOpened = true
                          // this.handleMessageSubmit(e)
                          this.handleSend(this.inputEl?.value)
                        }}
                      >
                        <i class="block ai-icon text-body1">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="currentColor" class="size-6">
                            <path
                              fill-rule="evenodd"
                              d="M8 14a.75.75 0 0 1-.75-.75V4.56L4.03 7.78a.75.75 0 0 1-1.06-1.06l4.5-4.5a.75.75 0 0 1 1.06 0l4.5 4.5a.75.75 0 0 1-1.06 1.06L8.75 4.56v8.69A.75.75 0 0 1 8 14Z"
                              clip-rule="evenodd"
                            ></path>
                          </svg>
                        </i>
                      </button>
                    </label>

                    <button
                      class={`${this.isContent && !this.isMinimized ? "block" : "hidden"} rounded-full isContent`}
                      aria-label="Return to AI"
                      onClick={ev => {
                        ev.preventDefault()
                        this.isContent = false
                        this.isOpened = true
                        this.isExpanded = true
                      }}
                    >
                      <div class="font-bold text-body2 text-white hidden md:flex pl-3 items-center">
                        Return to AI
                        <i class="inline-block pl-3 ai-minimize-icon block wes-icon--loading text-body1 return-text-color">
                          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 16" fill="none">
                            <path
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M1.30775 9.15362H14.077C14.4231 9.15362 14.577 9.5767 14.3462 9.80747L10.6539 13.4998C10.4231 13.7305 10.4231 14.0767 10.6539 14.3075L11.5001 15.1536C11.7308 15.3844 12.077 15.3844 12.3077 15.1536L19.0385 8.38439C19.2693 8.15362 19.2693 7.80747 19.0385 7.5767L12.3077 0.845928C12.077 0.615159 11.7308 0.615159 11.5001 0.845928L10.6924 1.65362C10.4616 1.88439 10.4616 2.23054 10.6924 2.46131L14.3847 6.15362C14.6154 6.42285 14.4616 6.84593 14.1154 6.84593H1.34621C1.03852 6.84593 0.769287 7.0767 0.769287 7.38439V8.53824C0.769287 8.84593 1.00006 9.15362 1.30775 9.15362Z"
                              fill="white"
                            ></path>
                          </svg>
                        </i>
                      </div>
                    </button>
                  </div>

                  {this.isExpanded && !this.isOpened && <privacy-modal show={this.showPrivacy} message={this.botSettings.privacyTemplate}></privacy-modal>}
                </div>
              </fieldset>
            </form>
            {/* )} */}

            <div
              // slot="bot"
              class="pointer-events-auto fixed right-7 whitespace-nowrap transition-transform duration-300 ease-in-out fab"
              style={{
                opacity: this.isMinimized ? "1" : "0",
                transform: this.isMinimized ? "translateX(0)" : "translateX(-100%)",
                pointerEvents: this.isMinimized ? "auto" : "none",
                transformOrigin: "50% 50% 0px",
              }}
              onClick={() => {
                this.openChat()
              }}
            >
              {this.isBot && <slot name="bot" />}
              {!this.isBot && (
                <button
                  class="rounded-full flex cursor-pointer items-center pr-[14px]  md:gap-x-3 focus:outline focus:outline-2 focus:outline-offset-2 focus:outline-blue-focused"
                  tabindex="0"
                  // onClick={() => {
                  //   this.openChat()
                  // }}
                >
                  {/* <div class="fixed bottom-4 left-4 flex items-center space-x-2 bg-gradient-to-r from-green-400 to-teal-500 text-white px-4 py-2 rounded-full shadow-lg"> */}
                  <div class="w-10 h-10 flex items-center justify-center bg-white rounded-full border relative">
                    {/* <div class="absolute bottom-[-2px] left-[3px] w-2 h-2 border-r-2 border-b-2 border-white rotate-45"></div> */}
                    {/* <svg class="w-5 h-5 text-gray-600" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" d="M9 12l2 2 4-4"></path>
                </svg> */}
                    {this.botSettings.botLaunchIcon && <img src={this.botSettings.botLaunchIcon} alt="bot icon" class="w-8 h-8 rounded-lg" />}

                    {!this.botSettings.botLaunchIcon && (
                      <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" stroke="#2095ae">
                        <g stroke-width="0"></g>
                        <g stroke-linecap="round" stroke-linejoin="round"></g>
                        <g>
                          {" "}
                          <path
                            d="M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                            stroke="#2095ae"
                            stroke-width="2"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                          ></path>{" "}
                        </g>
                      </svg>
                    )}
                  </div>
                  <span class="bot-name">Ask {this.botSettings?.botName}</span>
                </button>
              )}
            </div>
          </div>
        )}
      </div>
    )
  }
}
